import {
    Farm, Sector, CultivationPlot, MicroPlot, LegendItem, LegendProperties, LegendProperty, Observation, LegendGroup,
    Legend, LegendColor, JsonStyle, Intervention, farmConfig, LegendExtProperty,
    Fertilizer,
    DictionaryModel
} from '../_models/index';
import { Injectable, OnDestroy } from '@angular/core';
import { HandleService } from './handle.service';
import { FarmServices } from './farm.service';
import { mcPreconisation } from '../_models/beapi/mcPreconisation';
import { isNullOrEmptyString, isNullOrUndefined } from '../_helpers';
import { PrintManager, PrintPdfExtraModel } from '../_models/print/print_manager';
import { InterPrevi } from '../_models/beapi/interPrevi';
import { environment } from '../../environments/environment';
import { FarmerPrevisService } from './farmer-previs.service';
import { SharedMapService } from './map.service';
// Déclaration Openlayers
declare let ol: any;

@Injectable()
export class LegendService implements OnDestroy {

    ngOnDestroy(): void {
    }
    private _legdModulations = LegendsConfig.legdModulations;
    ///legende preconisation fumure step 4
    private _legdPrecoFumure = LegendsConfig.legdPrecoFumur;
    //legende preconisation pilotage azote SP
    private _legdPilotPreco = LegendsConfig.legPilotSpPreco;
    private _legdInterModePreco = LegendsConfig.legInterModePreco;

    //indique que selon la configuration on gère la duplication
    private _allowFarmerPrevisDuplicate = false;

    //legende farmer inter previs
    private _legdFarmerInterPrevis = LegendsConfig.legendFarmerInterPrevis;
    public ilotFeatures: any[] = [];
    public plotFeatures: any[] = [];
    public microFeatures: any[] = [];
    public legend: LegendGroup[] = [];
    public legendColorAttrs: Legend;
    ///indique si il a chargé par parcelle la legende conseil fumur
    private PlotAdviceFumurLegLoaded: boolean = false;

    /**Nom de la propriete Observation Conseil Azote:N */
    private ObsNameN: string = "FE_NAMC";
    /**Nom de la propriete Observation Conseil Azote:SO3 Soufre */
    private ObsNameSo3: string = "FE_SAMC";
    /**Nom de la propriete Observation Date ( N ou PK) */
    private ObsNameDate: string = "BA_DTCONS";
    /**Liste des clés d'observations pour le solde PK initial */
    private ObsBalancePkInitial = ["PANAINIT", "KANAINIT", "CAANAINIT", "MGANAINIT"];
    /**Liste des clés d'observations pour le solde PK Fertisol */
    private ObsBalancePkFertisol = ["PFERTISOL", "KFERTISOL", "CAFERTISOL", "MGFERTISOL"];
    private ObsTypePK = "0";
    /**Reprend les Modulation Preco Type Pour PDF */
    public ModPrecosTypes: String[] = [];
    /**Reprend les  Prestations diagnostic (annuels - Pilot LAI) Type Pour PDF */
    public DiagnosticPrestTypes: String[] = [];
    /**Reprend les Interventions en mode preco Pour PDF */
    public IntersModePreco: any;

    /**reprend les impressions supplémentaires formatées */
    public ExtrasPrintsModels: PrintPdfExtraModel[] = [];

    /**Groupe des editions avant les preconisations */
    public PrevPrecoPrinPdfModels: PrintPdfExtraModel[] = [];

    /** Conseil Azote Fumur unité u/ha des teneurs */
    public adviceNPKCompoDefaultUnit = 'u';

    /**campagne sélectionnée */
    private _currentCampaign:number= null;

    constructor(private _farmerPrevisService: FarmerPrevisService) {

    }

    clean() {
        this.ilotFeatures = [];
        this.plotFeatures = [];
        this.microFeatures = [];
        this.legend = [];
        this.legendColorAttrs = undefined;
        this.PlotAdviceFumurLegLoaded = false;
        this.ModPrecosTypes = [];
        this.DiagnosticPrestTypes = [];
        this.IntersModePreco = [];
        this.ExtrasPrintsModels = [];
        this.PrevPrecoPrinPdfModels =[];

    }


    /**
     * Chargement des données
     * @param farms données chargées pour la camapgne sélectionnées ( incluant données annuels rendement campagne N+1)
     * @param campaignSelected camapgne sélectionnée
     * @returns 
     */
    loadFeatures(farms: Farm[], campaignSelected:number|null): any {

        this._currentCampaign = campaignSelected;
        this._allowFarmerPrevisDuplicate = FarmerPrevisService.ConfigEnableDuplication() == true && this._farmerPrevisService.IsDuplicationAccess == true;

        if (farms === null || farms === undefined || farms.length === 0)
            return;
        this.ilotFeatures = [];
        this.plotFeatures = [];
        this.microFeatures = [];
        this.legend = [];
        let p205 = false;

        let balancePkInitialsValues = new DictionaryModel(null);
        let balancePkReactsValues = new DictionaryModel(null);

        this.PlotAdviceFumurLegLoaded = false;

        //liste distincte des P2O5EpiclesNames micros fertis présent dans toutes les exploitations passées
        let farmsP2o5s = this.GetDistinctFarmsP205EpiclesName(farms);
        let PrestMajorPO5Name = null;

        if (farmsP2o5s.length) {
            PrestMajorPO5Name = farmsP2o5s[0];
            if (farmsP2o5s.length > 1) {
                //priorise P2O5_OL
                if (farmsP2o5s.includes('P2O5_OL')) {
                    PrestMajorPO5Name = 'P2O5_OL';
                }
            }
        }

        let propsObsbalancePk = [... this.ObsBalancePkInitial, ... this.ObsBalancePkFertisol]

        let includeRegPilotSP=false;
        farms.forEach(sector => {

            if (sector.Sectors === null)
                return;
            /// indique si sur l exploitation on est sur prestation Pack ou Potentiel (pour les conseil Azote epicles)
            let _blFarmPrestPot: boolean = sector.PresTypePack() || sector.PresTypePotentiel();

            let _blModulation = sector.PresTypeModulation();
            let _blAnnual = sector.IsAnnualOrder();
            //cas diag annuel rendement campagne +1;
            let isAnnualNextCmp = _blAnnual && this._currentCampaign >0 &&  sector.IdCampagne >0 && this._currentCampaign < sector.IdCampagne;
            //si c est un diagnostic pilot sp LAI
            let _blIsDiagLai = sector.IsDiagPilotSPLAI();

            // si c est un diagnostic (LAI ou Annuel)
            let _blIsDiagnostic = sector.IsDiagnostic();
            let _blPilotSpLAI = sector.IsOrderPilotSPLAI();

            if(!includeRegPilotSP && _blPilotSpLAI){
                includeRegPilotSP= true;
            }

            if (_blModulation) {
                if (!FarmServices.IncludePlotModulation(sector)) {// ORDER modulation AVEC au - 1 preconisation
                    return;
                }
            }

            sector.Sectors.forEach(element => {
                let geom = element.Geometry;
                if (geom === null && !_blIsDiagnostic)
                    return;
                if (!_blIsDiagnostic && !_blPilotSpLAI && !_blModulation) {

                    let polylines = new ol.geom.Polygon(geom.coordinates);
                    if (polylines.flatCoordinates) {
                        let featureIlot = new ol.Feature({
                            geometry: polylines,
                            properties: this.loadIlotProperties(sector, element)
                        })
                        this.ilotFeatures.push(featureIlot);
                    }
                }

                //add plot
                if (element.CultivationPlots == null)
                    return;

                this.PlotAdviceFumurLegLoaded = false;/*recharge par parcelle */

                element.CultivationPlots.forEach(fPlot => {
                    let geometryPlot = fPlot.Geometry;
                    if (geometryPlot == null && !_blIsDiagnostic)
                        return;

                    let polylinesPlot = !_blIsDiagnostic ? new ol.geom.Polygon(geometryPlot.coordinates) : null;
                    //on evite la superposition , le step Order (dont decoule modulation et pilot sp) reste le principale
                    if ((polylinesPlot && polylinesPlot.flatCoordinates && !_blPilotSpLAI && !_blModulation) || _blIsDiagnostic) {
                        let featurePlot = new ol.Feature({
                            geometry: polylinesPlot,
                            properties: this.loadParcelleProperties(sector, element, fPlot, farms[0].IdCampagne)
                        })
                        this.plotFeatures.push(featurePlot);

                    }
                    if (fPlot.MicroPlots == null)
                        return;

                    /** conserve le dernier Observation N type de la plot*/
                    let _plotMajorObsNType: string = _blFarmPrestPot ? this.getMajorObsTypeWithValue(fPlot, this.ObsNameN) : null;
                    /** conserve le dernier Observation SO3 type de la plot*/
                    let _plotMajorObsSO3Type: string = _blFarmPrestPot  ? this.getMajorObsTypeWithValue(fPlot, this.ObsNameSo3) : null;

                    /**arrondit des doses et de legendes des prévis selon  */
                    if (fPlot.ExistInterPrevis()) {
                        fPlot.RoundInterPrevisUnitDoses();
                    }
                    fPlot.MicroPlots.forEach(micro => {

                        let microPlotGeometry = micro.Geometry;
                        if (microPlotGeometry == null)
                            return;

                        if (!p205) {
                            this.loadLegendStatic(farms, PrestMajorPO5Name);
                        }

                        p205 = true
                        let polylinesMicro = new ol.geom.Polygon(microPlotGeometry.coordinates);
                        if (polylinesMicro == null)
                            return;

                        let featureMicro = new ol.Feature({
                            geometry: polylinesMicro,
                            nameIlot: element.Name,
                            namePlot: fPlot.NameCultivationPlot,
                            nameMicro: micro.Name,
                            farm: sector,
                            properties: this.loadMicroParcelleProperties(sector, element, fPlot, micro, _blFarmPrestPot, _plotMajorObsNType, _plotMajorObsSO3Type, _blModulation, _blAnnual, _blIsDiagLai, isAnnualNextCmp)

                        });
                        if(micro.Surface< 0.001){
                            let status = SharedMapService.IsMicroFeatureExtendOnPolygon(featureMicro);
                            if(status == 2){
                                //le centroide de l'extend est hors du contour de la micro on indique à a propriété
                                featureMicro.set(SharedMapService.PROP_EXTEND_OUT_OF_BOUNDARY,true);        
                            }
                        }
                       
                        //selon les données constituées, maj des rangs de valeurs de teneurs si présent
                        balancePkInitialsValues = this.ComputeOrdersRangsBalances(balancePkInitialsValues, balancePkReactsValues, this.getObservations(micro, propsObsbalancePk))
                        this.microFeatures.push(featureMicro);
                    })
                })
            });

        });

        this.ClearEmptyStyleLegend(LegendsConfig.legdAnnaRend);
        this.ClearOnEmptyLegend(LegendsConfig.legdAnnaRend);

        this.ClearEmptyStyleLegend(LegendsConfig.legdAnnaRendCmpN1);
        this.ClearOnEmptyLegend(LegendsConfig.legdAnnaRendCmpN1);
       
        this.ClearEmptyStyleLegend(LegendsConfig.legdAnnaAzote);
        this.ClearEmptyStyleLegend(LegendsConfig.legdAnnaCarboN);
        this.ClearOnEmptyLegend(LegendsConfig.legdPilotSpLAI);

        if (balancePkInitialsValues.Exists()) {
            //il va constituer les legendes interface si dispose de teneurs
            if (this.bindAdvicePKBalanceLegends(balancePkInitialsValues, balancePkReactsValues) == false) {
                //aucune teneur présente
                this.legend.find(a => a.key == LegendsConfig.legdAdvicePkBalance)?.RemoveItems();
            }
        }

        //suppression de légende si pas de données
        this.ClearOnEmptyLegend(LegendsConfig.legdAdvicePkBalance);

        this.ClearOnEmptyLegend(this._legdModulations);
        this.ClearOnEmptyLegend(this._legdInterModePreco);
        this.ClearOnEmptyLegend(this._legdFarmerInterPrevis);
        this.OrderLegends();

        this.ModPrecosTypes = this.getPDFModulationTypes();
        this.DiagnosticPrestTypes = this.GetPDFDiagnosticTypes();
        this.ExtrasPrintsModels = this.getPDFExtraPrintTypes();

        if(includeRegPilotSP){
          this.PrevPrecoPrinPdfModels.push(PrintManager.FormatPdfTypePilotSpAdviceNReg());
        }

     
    }

    loadIlotProperties(farm: Farm, ilot: Sector): LegendProperties[] {
        if (!ilot) return null;
        let ilotLegendProperties: LegendProperty[] = [];
        ilotLegendProperties.push(
            this.InitLegendProperty("Exploitation", farm.NameExploitation)
        )
        ilotLegendProperties.push(
            this.InitLegendProperty("Ilot n°", ilot.PacNumber.toString())
        )
        return [{
            legendGroupKey: "Assolement",
            legendItemKey: "Ilots",
            legendProperies: ilotLegendProperties,
        }];
    }

    loadParcelleProperties(farm: Farm, ilot: Sector, parcelle: CultivationPlot, IdCampagne: number): LegendProperties[] {
        if (!parcelle) return null;
        let parcelLegendProperties: LegendProperty[] = [];
        let parcelPreviousLegendProperties: LegendProperty[] = [];
        parcelLegendProperties.push(
            this.InitLegendProperty("Exploitation", farm.NameExploitation),
            this.InitLegendProperty("Parcelle", this.FormatPlotWithAreaText(parcelle)),
            this.InitLegendProperty("Ilot n°", ilot.PacNumber.toString()),
            this.InitLegendProperty("Campagne", IdCampagne.toString()),
            this.InitLegendProperty("Culture_color", parcelle.CultivationSelected ? parcelle.CultivationSelected.Color : "", null, false),
            this.InitLegendProperty("Culture", parcelle.CultivationSelected ? parcelle.CultivationSelected.Name : ""),
            this.InitLegendProperty("Variété", parcelle.SpecieSelected ? parcelle.SpecieSelected.Name : "")
        );
        parcelPreviousLegendProperties.push(
            this.InitLegendProperty("Exploitation", farm.NameExploitation),
            this.InitLegendProperty("Parcelle", this.FormatPlotWithAreaText(parcelle)),
            this.InitLegendProperty("Ilot n°", ilot.PacNumber.toString()),
            this.InitLegendProperty("Campagne", (IdCampagne - 1).toString()),
            this.InitLegendProperty("Culture_color", parcelle.PreviousCultivationSelected ? parcelle.PreviousCultivationSelected.Color : "", null, false),
            this.InitLegendProperty("Culture", parcelle.PreviousCultivationSelected ? parcelle.PreviousCultivationSelected.Name : ""),
        )
        return [{
            legendGroupKey: "Assolement",
            legendItemKey: IdCampagne.toString(),
            legendProperies: parcelLegendProperties,

        }, {
            legendGroupKey: "Assolement",
            legendItemKey: (IdCampagne - 1).toString(),
            legendProperies: parcelPreviousLegendProperties,
        }];

    }


    /**
     *   Retourne les propriétes voulues en fonction du code groupe passer en parametre
     * @param farm
     * @param sector
     * @param cultivationPlot
     * @param microPlot
     * @param blPrestPotent Indique que c est une prestation Potentiel ou Pack
     * @param plotMajorObsNType Observation Type Majour au Plot pour conseil Azote N
     * @param plotMajorObsSo3Type Observation Type Majour au Plot pour conseil Azote SO3
     * @param _iblIsModulation indique si on est sur un order modulation
     * @param _iblIsAnnual indique si on est sur un diagnostic annuel ( RDT ou Azote)
     * @param _iblIsDiagLai indique si on est sur un diagnostic Pilot Azote SP LAI
     * @param _iblIsAnnualNextCmp indique qu n est en diag annuel campagne n+1
     */
    loadMicroParcelleProperties(farm: Farm, sector: Sector, cultivationPlot: CultivationPlot, microPlot: MicroPlot, blPrestPotent: boolean, plotMajorObsNType: string, plotMajorObsSo3Type: string, _iblIsModulation: boolean, _iblIsAnnual: boolean = false, _iblIsDiagLai: boolean = false, _iblIsAnnualNextCmp:boolean =false): LegendProperties[] {

        let returnList: LegendProperties[] = [];
        let _blMicroIncludeObs: boolean = microPlot.Observations != null && microPlot.Observations.length > 0;

        let _blMicroPk = false;
        let _blMicroN = false;

        let _isDiagnostic = _iblIsAnnual == true || _iblIsDiagLai;
        let _blPilotOrder = !_iblIsDiagLai && farm.IsOrderPilotSPLAI();
        //si l'order est en GRCETA (il peut provenr d un step 1 PACK et donc avec du potentiel)
         let isGrCeta = !_iblIsDiagLai && !_blPilotOrder && farm.PresTypeGRCETA();
        let _cloneMicro = new MicroPlot(microPlot, true);
        _blMicroPk = !_iblIsModulation && !_isDiagnostic && !_blPilotOrder ? _cloneMicro.IsFerti() : false;
        _blMicroN = !_iblIsModulation && !_isDiagnostic && !_blPilotOrder ? _cloneMicro.IsPotentiel() : false;

        let P2O5Type: string = null;

        if (microPlot.MicroPlotDetails.P205EpiclesName != null) {
            let P2O5UppEpicName: string = microPlot.MicroPlotDetails.P205EpiclesName.toUpperCase();
            if (P2O5UppEpicName === 'P2O5_OL')
                P2O5Type = 'Olsen';
            else if (P2O5UppEpicName === 'P2O5_JH')
                P2O5Type = 'Joret Hébert';
            else if (P2O5UppEpicName === 'P2O5_DY')
                P2O5Type = 'Dyer';
        }

           let emptyStoneRate =isGrCeta ? "" : "0 %";
        if (_blMicroPk) {
          
            /// >>Diagnostic fertilité
            let dictvaluesFertilite = new Array<LegendProperty>();
            dictvaluesFertilite.push(
                this.InitLegendProperty("Exploitation", farm.NameExploitation),
                this.InitLegendProperty("Parcelle", this.FormatPlotWithAreaText(cultivationPlot)),
                this.InitLegendProperty("Ilot", sector.PacNumber != null ? sector.PacNumber.toString() : ""),
                this.InitLegendProperty("Date", HandleService.getStringLocalDate(microPlot.MicroPlotDetails.AnalysisDate)),
                this.InitLegendProperty("Identifiant microparcelle", (microPlot.MicroPlotDetails.IdBeApi != null ? microPlot.MicroPlotDetails.IdBeApi.toString() : "")),
                this.InitLegendProperty("Identifiant conseil", microPlot.Id.toString()),
                this.InitLegendProperty("pH", (Math.round(microPlot.MicroPlotDetails.PhWater * 100) / 100).toString()),
                this.InitLegendProperty("Teneur prise en compte pour le conseil", P2O5Type),
                this.InitLegendProperty("K2O", (microPlot.MicroPlotDetails.K2O != null ? microPlot.MicroPlotDetails.K2O.toString() : ""), 'ppm'),
                this.InitLegendProperty("MgO", (microPlot.MicroPlotDetails.MgO != null ? microPlot.MicroPlotDetails.MgO.toString() : ""), 'ppm'),
                this.InitLegendProperty("CaO", (microPlot.MicroPlotDetails.Limestone != null ? microPlot.MicroPlotDetails.Limestone.toString() : ""), 'ppm'),
                this.InitLegendProperty("K2O/MgO", (microPlot.MicroPlotDetails.K2OMGO != null ? (Math.round(microPlot.MicroPlotDetails.K2OMGO * 100) / 100).toString() : "")),
                this.InitLegendProperty("CEC", (microPlot.MicroPlotDetails.CEC != null ? microPlot.MicroPlotDetails.CEC.toString() : ""), 'meq/100g'),
                this.InitLegendProperty(LegendsConfig.legLibFertiMATORG, (microPlot.MicroPlotDetails.MATORG != null ? (Math.round(microPlot.MicroPlotDetails.MATORG * 100) / 100).toString() : ""), '%'), 
               
                this.InitLegendProperty("<br>Profil pédologique", microPlot.MicroPlotDetails.SoilType),
                this.InitLegendProperty("Taux de cailloux dans le sol", (microPlot.MicroPlotDetails.SoilRateStone != null ? microPlot.MicroPlotDetails.SoilRateStone.toString() + " %" : emptyStoneRate), '%'),
                this.InitLegendProperty("Profondeur d’enracinement", (microPlot.MicroPlotDetails.RootingDepth != null ? microPlot.MicroPlotDetails.RootingDepth.toString() : ""), 'cm'),
                this.InitLegendProperty("Profondeur du sol", (microPlot.MicroPlotDetails.SoilDepth != null ? microPlot.MicroPlotDetails.SoilDepth.toString() : ""), 'cm'),
             
                this.InitLegendProperty("<br>N° analyse", microPlot.MicroPlotDetails.AnalysisNumber),
                this.InitLegendProperty("Laboratoire", microPlot.MicroPlotDetails.LaboratoryName)
            )

            let indexLastP2O5: number = 7;

            if (microPlot.MicroPlotDetails.P2O5OL != null && microPlot.MicroPlotDetails.P2O5OL != 0.0) {
                dictvaluesFertilite.splice(indexLastP2O5, 0, this.InitLegendProperty("P2O5 Olsen", (microPlot.MicroPlotDetails.P2O5OL != null ? microPlot.MicroPlotDetails.P2O5OL.toString() : ""), 'ppm'))
                indexLastP2O5 = indexLastP2O5 + 1;
            }
            if (microPlot.MicroPlotDetails.P2O5JH != null && microPlot.MicroPlotDetails.P2O5JH != 0.0) {
                dictvaluesFertilite.splice(indexLastP2O5, 0, this.InitLegendProperty("P2O5 Joret Hébert", (microPlot.MicroPlotDetails.P2O5JH != null ? microPlot.MicroPlotDetails.P2O5JH.toString() : ""), 'ppm'))
                indexLastP2O5 = indexLastP2O5 + 1;
            }
            if (microPlot.MicroPlotDetails.P2O5DY != null && microPlot.MicroPlotDetails.P2O5DY != 0.0) {
                dictvaluesFertilite.splice(indexLastP2O5, 0, this.InitLegendProperty("P2O5 Dyer", (microPlot.MicroPlotDetails.P2O5DY != null ? microPlot.MicroPlotDetails.P2O5DY.toString() : ""), 'ppm'))
                indexLastP2O5 = indexLastP2O5 + 1;
            }
            if (indexLastP2O5 == 7 && isNullOrUndefined(P2O5Type)) {/*Pas d info P2O5 */
                dictvaluesFertilite.splice(7, 1);
            }

            if(isGrCeta){
                //suppression des propriétés vide, "", ou null ou undefined
                  dictvaluesFertilite = this.RemoveLegendPropertiesEmptyValue(dictvaluesFertilite,true);
            }

            returnList.push({
                legendGroupKey: LegendsConfig.legDiagFerti,
                legendItemKey: "",
                legendProperies: dictvaluesFertilite,
            });

        }
        // >>Conseil AZOTE
        if (_blMicroN) {
            if (blPrestPotent && _blMicroIncludeObs && !isGrCeta) {
                returnList.push(this.LoadLegendConsAzote(farm, sector, cultivationPlot, microPlot, plotMajorObsNType, plotMajorObsSo3Type));
            }
            // >>Diagnostic Potentiel
            let dictvaluesPotentiel = new Array<LegendProperty>();
            dictvaluesPotentiel.push(
                this.InitLegendProperty("Exploitation", farm.NameExploitation),
                this.InitLegendProperty("Parcelle", this.FormatPlotWithAreaText(cultivationPlot)),
                this.InitLegendProperty("Ilot", sector.PacNumber != null ? sector.PacNumber.toString() : ""),
                this.InitLegendProperty("Date", HandleService.getStringLocalDate(microPlot.MicroPlotDetails.MeasuredDate)),
                this.InitLegendProperty("Identifiant microparcelle", microPlot.MicroPlotDetails.IdBeApi),
                this.InitLegendProperty("Identifiant conseil", (microPlot.Id != null ? microPlot.Id.toString() : "")),
                this.InitLegendProperty("Potentiel", (microPlot.MicroPlotDetails.SoilPotential != null ? microPlot.MicroPlotDetails.SoilPotential.toString() : "")),
                this.InitLegendProperty("Réserve utile totale", (microPlot.MicroPlotDetails.RU_TOT != null ? microPlot.MicroPlotDetails.RU_TOT.toString() : ""), 'mm'),
                this.InitLegendProperty("Humidité capacité au champ", (microPlot.MicroPlotDetails.HCC_TOT != null ? microPlot.MicroPlotDetails.HCC_TOT.toString() : ""), '%'),
                this.InitLegendProperty("<br>Profil pédologique", microPlot.MicroPlotDetails.SoilType),
                this.InitLegendProperty("Type de sol (Epiclès)", (cultivationPlot.GroundTypeSelected) ? cultivationPlot.GroundTypeSelected.Name : ""),
                this.InitLegendProperty("Taux de cailloux dans le sol", (microPlot.MicroPlotDetails.SoilRateStone != null ? microPlot.MicroPlotDetails.SoilRateStone.toString() + " %" : ""), '%'),
                this.InitLegendProperty("Profondeur d’enracinement", (microPlot.MicroPlotDetails.RootingDepth != null ? microPlot.MicroPlotDetails.RootingDepth.toString() : ""), 'cm'),
                this.InitLegendProperty("Profondeur du sol", microPlot.MicroPlotDetails.SubSoilDepth != null ? microPlot.MicroPlotDetails.SubSoilDepth.toString() : "", 'cm'))

            if (microPlot.MicroPlotDetails.CE1 != null) {
                dictvaluesPotentiel.splice(6, 0,
                    this.InitLegendProperty("Conductivité électrique", (microPlot.MicroPlotDetails.CE1 ? microPlot.MicroPlotDetails.CE1.toString() : ""), 'millisiemens/m'))
            }
            if (microPlot.MicroPlotDetails.APM) {
                dictvaluesPotentiel.splice(10, 0,
                    this.InitLegendProperty("APM", (microPlot.MicroPlotDetails.APM ? microPlot.MicroPlotDetails.APM.toString() : ""), ''))
            }

             if(isGrCeta){
                //suppression des propriétés vide, "", ou null ou undefined
                  dictvaluesPotentiel = this.RemoveLegendPropertiesEmptyValue(dictvaluesPotentiel,true);
            }

            returnList.push({
                legendGroupKey: LegendsConfig.legDiagPot,
                legendItemKey: "",
                legendProperies: dictvaluesPotentiel,
            });
            let legendPotItem = this.legend.find(a => a.key != null && a.key.toUpperCase() === LegendsConfig.legDiagPot.toUpperCase());
            if (legendPotItem != null && legendPotItem.items != null && farm.Legends != null && farm.Legends.length > 0) {
                legendPotItem.items.forEach(item => {
                    if (item.name != null) {
                        if (item.name.toUpperCase() === "POTENTIEL") {
                            this.BindingLegendsStyles(item, farm.Legends, "POTENTIEL", "Potentiel");
                        }
                        /*RU et HCC Nommage Selon legend.Service */
                        else if (item.name.toUpperCase() === "RU") {
                            this.BindingLegendsStyles(item, farm.Legends, "RU_TOT", "Réserve utile totale");
                        }
                        else if (item.name.toUpperCase() === "HCC") {
                            this.BindingLegendsStyles(item, farm.Legends, "HCC_TOT", "Humidité capacité au champ");
                        } else if (item.name.toUpperCase() === LegendsConfig.legPotentielAPM) {
                            this.BindingLegendsStyles(item, farm.Legends, "APM", "APM");
                        }
                    }
                });

            }
        }

        if (_blMicroPk) {
            /// >>Conseil fumure
            let dictAdviceFumure = new Array<LegendProperty>();
            dictAdviceFumure = this.InitBasicProperties(farm, sector, cultivationPlot, microPlot, false);
            dictAdviceFumure.push(
                this.InitLegendProperty("Date conseil", (_blMicroIncludeObs && this.getObservation(microPlot, this.ObsNameDate, this.ObsTypePK, true) != null
                    ? HandleService.getLOCALDate(this.getObservation(microPlot, this.ObsNameDate, this.ObsTypePK, true).Value)
                    : "")),
                this.InitLegendProperty("Objectif de rendement", microPlot.MicroPlotDetails.ObjectifRendement, "T/ha"),
                this.InitObsLegendProperty("P2O5", _blMicroIncludeObs, microPlot.Observations, "FE_PAMC"),
                this.InitObsLegendProperty("K2O", _blMicroIncludeObs, microPlot.Observations, "FE_KAMC"),
                this.InitObsLegendProperty("MgO", _blMicroIncludeObs, microPlot.Observations, "FE_MGAMC"),
                this.InitObsLegendProperty("CaO", _blMicroIncludeObs, microPlot.Observations, "FE_CAAMC"),
            );

            if(isGrCeta){
                //supprime objectif rendement si pas de cosneil ils sont supprimés du tooltip
                dictAdviceFumure = this.RemoveLegendPropertiesEmptyValue(dictAdviceFumure,true);
            }
          
            returnList.push({
                legendGroupKey: LegendsConfig.legdAdvicePk,
                legendItemKey: "",
                legendProperies: dictAdviceFumure,
            });

            // chargement des legendes ( component left)
            let legendItem = this.legend.find(a => a.key === LegendsConfig.legdAdvicePk);

            if (legendItem && (!this.PlotAdviceFumurLegLoaded) && _blMicroIncludeObs) {
                  
                let CntLoaded: number = 0;
                legendItem.items.forEach(item => {
                    if (item.legendName === "P2O5") {
                        if (this.BindingReqObsStyles(item, "FE_PAMC", microPlot))
                            CntLoaded++;
                    }
                    else if (item.legendName === "K2O") {
                        if (this.BindingReqObsStyles(item, "FE_KAMC", microPlot))
                            CntLoaded++;
                    }
                    else if (item.legendName === "MgO") {
                        if (this.BindingReqObsStyles(item, "FE_MGAMC", microPlot))
                            CntLoaded++;

                    }
                    else if (item.legendName === "CaO") {
                        if (this.BindingReqObsStyles(item, "FE_CAAMC", microPlot))
                            CntLoaded++;
                    }
                    if (CntLoaded > 3)/*il en a chargé sur la micro pour la current parcelle */
                        this.PlotAdviceFumurLegLoaded = true;
                })
            }

            if(!isGrCeta){
            //#region Solde Conseil PK
            let props = [... this.ObsBalancePkInitial, ... this.ObsBalancePkFertisol]
            let compoBalancePk = this.getObservations(microPlot, props);

            let compoUnit = this.adviceNPKCompoDefaultUnit;
            if (compoBalancePk == null) {
                //il a du conseil PK MAIS pas de calcul on visualise les micros et la synthèse sans valeur teneurs
                compoBalancePk = new DictionaryModel();
            }

            let dictbalanceAdviceFumure = new Array<LegendProperty>();
            dictbalanceAdviceFumure = this.InitBasicProperties(farm, sector, cultivationPlot, microPlot, false);
            dictbalanceAdviceFumure.push(...this.FormatLegPkBalanceSynthesis(compoBalancePk, compoUnit));
            returnList.push({
                legendGroupKey: LegendsConfig.legdAdvicePkBalance,
                legendItemKey: "",
                legendProperies: dictbalanceAdviceFumure,
            });

            //#endregion
            }
         
        }

        /// >>Modulation fumure || pilot SP LAI
        if (cultivationPlot && cultivationPlot.Preconisations)
            if (!_iblIsModulation) {
                let legendPreco = !_blPilotOrder ? this._legdPrecoFumure : this._legdPilotPreco;

                
                if (cultivationPlot.MicroPlots != null && cultivationPlot.MicroPlots.length > 0)
                    for (let i = 0; i < cultivationPlot.Preconisations.length; i++) {
                        let _plPreco: Intervention = new Intervention(cultivationPlot.Preconisations[i]);

                       
                        if (!microPlot.Preconisations || this.IsEmptyFertiDose(_plPreco) || !_plPreco.IncludeIdent()) {
                            continue;
                        }
                        //si il a pas de preco ou pas de dose à la plot ou la micro on remplit pas
                        let _currMcPreco: mcPreconisation = null;
                        if (!this.IncludeMcPrecoDoseByIdent(cultivationPlot, _plPreco.Ident)) {//aucune micro de la plot ne dispose de dose >0
                            continue;
                        }
                        _currMcPreco = microPlot.Preconisations.find(t => this.EqualByIdent(t, _plPreco.Ident));
                        if (!_currMcPreco || this.IncludeMcFertiDose(_currMcPreco, false) == false) {
                            continue;
                        }
                        let _plPrcFerti = _plPreco.Fertilizer;
                        let precoProductLegendName = _plPrcFerti.Name + " - " + HandleService.getLOCALDate(_plPreco.BeginDate);

                        let dictvaluesModulationFumure = [];
                        dictvaluesModulationFumure = this.FormatCommonPrecoLegend(farm, sector, cultivationPlot);
                        dictvaluesModulationFumure.push(...this.InitLgendPropertiesMcPreco(microPlot, _plPreco, _currMcPreco, !_blPilotOrder))

                        returnList.push({
                            legendGroupKey: legendPreco,
                            legendItemKey: precoProductLegendName,
                            legendProperies: dictvaluesModulationFumure,

                        });

                        let legendItem = this.legend.find(a => a.key == legendPreco);
                        if (legendItem && legendItem.items && !legendItem.items.find(a => a.legendName == precoProductLegendName)) {

                            let oPrecoLegend = this.formatLegendItem(legendPreco, precoProductLegendName, _plPrcFerti.Unit.length ? _plPrcFerti.Unit + '/ha' : '', _plPreco.Legend);

                            let allowDuplication = this._allowFarmerPrevisDuplicate == true;

                            //les préconisations organiques GRCETA ne peuvent être dupliquées
                            let lockPrecoOrga =(isGrCeta && _plPreco.IsPrecoOrganic());
                            if(lockPrecoOrga){
                                allowDuplication = false;
                            }

                            if (allowDuplication && this._farmerPrevisService.FertilizerWithComposition(_plPrcFerti) == false) {
                                //cas d'un produit sans teneur gérée on masque la duplication
                                allowDuplication = false
                            }

                           
                            if (!_iblIsModulation && allowDuplication == true) {
                                //pilot SP Order

                                oPrecoLegend.canBeFarmerDuplicated = true;
                                oPrecoLegend.uniqueFormatedId = FarmerPrevisService.FormatTechPrecoId(_plPreco, _blPilotOrder);

                                if (isNullOrEmptyString(oPrecoLegend.uniqueFormatedId)) {
                                    //impossible de constituer l'id unique codeproduit ou date manquant
                                    oPrecoLegend.canBeFarmerDuplicated = false;
                                }
                            }
                            legendItem.items.push(oPrecoLegend)
                        }


                        else if (legendItem) {// contrôle que le style est pas superieur
                            this.BindingLegendStyles(legendItem.items.find(a => a.legendName == precoProductLegendName), _plPreco.Legend, null, true, true);
                        }
                    }
                this.OrderLegend(legendPreco, true);
                this.OrderLegend("Assolement", false);
            }
            else {//donnees de modulation
                let UnitNoArea = ['%', 'mm', 'grm2'];
                let endUnitNoArea = ['/ha', '/m2', '/m²'];
                let _propMcValMashVol = LegendsConfig.legLibMashVolumeValue;
                let _propMashUnit = 'l/ha';
                let _propDose = LegendsConfig.legLibModulationPdtDose;
                for (let dxprcPlot = 0; dxprcPlot < cultivationPlot.Preconisations.length; dxprcPlot++) {
                    let _plotPrec = cultivationPlot.Preconisations[dxprcPlot];
                    //recherche selon IdGroupe
                    let _mcPrec = microPlot.Preconisations.find(t => t.IdGroupe == _plotPrec.IdGroupe)
                    //si il a pas de preco ou pas de dose à la plot ou la micro on remplit pas
                    if (!_mcPrec || this.IncludeFertiDose(_plotPrec, false) == false || this.IncludeMcFertiDose(_mcPrec, false) == false) {
                        continue;
                    }

                    let precoType = _plotPrec.InterventionType ? _plotPrec.InterventionType.Name : null;
                    let precoTypeCode = _plotPrec.InterventionType ? _plotPrec.InterventionType.Code : null;
                    let precoProductLegendName = _plotPrec.Fertilizer.Name + " - " + HandleService.getLOCALDate(_plotPrec.BeginDate);

                    let PlotNameArea = this.FormatPlotWithAreaText(cultivationPlot)
                    let areaUnit = _plotPrec.Fertilizer.Unit && UnitNoArea.indexOf(_plotPrec.Fertilizer.Unit) == -1 && endUnitNoArea.findIndex(e=> _plotPrec.Fertilizer.Unit.endsWith(e)) == -1 ? '/ha' : '';
                    let blIncludBouille = Intervention.IsModulationBouillie(_plotPrec);
                    let _mcBouil = null;
                    let _mcdose = _mcPrec.Fertilizer.Dose;

                    let _Refdose = _plotPrec.RefDose != null && _plotPrec.RefDose != undefined ? _plotPrec.RefDose : 0;
                    let _plotdose = _plotPrec.Fertilizer.Dose != null && _plotPrec.Fertilizer.Dose != undefined ? _plotPrec.Fertilizer.Dose : 0;

                    let prdUnit = _plotPrec.Fertilizer.Unit.length ? _plotPrec.Fertilizer.Unit + areaUnit : '';
                    if (blIncludBouille) {
                        _mcBouil = 0;

                        let _plvolBouil = _plotPrec.ModDatas.Value;

                        if (_mcdose > 0 && _Refdose > 0 && _plvolBouil) {
                            _mcBouil = Math.round((_mcdose * _plvolBouil) / _Refdose)
                        }
                    }

                    let dictvaluesModulations = [];
                    dictvaluesModulations.push(
                        this.InitLegendProperty("Exploitation", farm.NameExploitation),
                        this.InitLegendProperty("Ilot", sector.PacNumber != null ? sector.PacNumber.toString() : ""),
                        this.InitLegendProperty("Parcelle", PlotNameArea),
                        this.InitLegendProperty("Culture", cultivationPlot.CultivationSelected ? cultivationPlot.CultivationSelected.Name : ""),
                        this.InitLegendProperty("Produit", _plotPrec.Fertilizer.Name),
                        this.InitLegendExistProperty(_propMcValMashVol, _mcBouil, _propMashUnit, blIncludBouille),
                        this.InitLegendExistProperty("Volume de bouillie de référence", blIncludBouille ? _plotPrec.ModDatas.Value : null, _propMashUnit, blIncludBouille),
                        this.InitLegendProperty(_propDose, _mcdose, prdUnit, true),
                        this.InitLegendProperty("Dose moyenne à la parcelle", _plotdose, prdUnit),
                        this.InitLegendProperty("Date de l'apport", HandleService.getLOCALDate(_plotPrec.BeginDate))
                    );
                    if (!isNullOrEmptyString(_mcPrec.Comm)) {
                        dictvaluesModulations.push(
                            this.InitLegendProperty("Commentaire", _mcPrec.Comm),
                        )
                    }
                    if (!blIncludBouille && _plotPrec.ModDatas && _plotPrec.ModDatas.Type == "PMG") {
                        dictvaluesModulations.push(
                            this.InitLegendExistProperty("PMG de référence", _plotPrec.ModDatas.Value, "g")
                        )
                    }
                    dictvaluesModulations = this.ClearNullPropertie(dictvaluesModulations);
                    returnList.push({
                        legendGroupKey: this._legdModulations,
                        legendItemKey: precoProductLegendName,
                        legendProperies: dictvaluesModulations
                    });

                    let legendItem = this.legend.find(a => a.key == this._legdModulations);
                    if (legendItem && !legendItem.items.find(a => a.legendName == precoType)) {//groupe intervention
                        legendItem.items.push(this.formatLegendItem(this._legdModulations, precoType, null, null, true, precoTypeCode, _plotPrec.InterventionTypeGroup ? _plotPrec.InterventionTypeGroup.Name : null))
                    }
                    if (legendItem && legendItem.items.find(a => a.legendName == precoType)) {//les modulation
                        let legModType = legendItem.items.find(a => a.legendName == precoType);
                        let legModTypeProduit = isNullOrUndefined(legModType) == false ? legModType.items.find(a => a.legendName == precoProductLegendName) : null;
                        let _blExistLegdproduct = (isNullOrUndefined(legModTypeProduit) == false);// on dispose d'une legende produit existante
                        if (legModType && _blExistLegdproduct == false) {
                            //non trouvé selon le nom de produit
                            let formatUit = _plotPrec.Fertilizer.Unit.length ? _plotPrec.Fertilizer.Unit + areaUnit : _plotPrec.Fertilizer.Unit;
                            let _modLegend = this.formatLegendItem(this._legdModulations, precoProductLegendName, formatUit, _plotPrec.Legend, false, null);
                            if (blIncludBouille && _mcBouil > 0) {

                                _modLegend.externeProp = new LegendExtProperty(_propMcValMashVol, _mcBouil, _propMashUnit, _mcBouil);
                            }
                            legModType.items.push(_modLegend)
                        }
                        else if (legModType && blIncludBouille && _mcBouil > 0) {
                            let onr = legModType.items.find(a => a.legendName == precoProductLegendName);

                            if (onr && onr.externeProp && onr.externeProp.propertyValue) {
                                //gestion max
                                if (Number(onr.externeProp.propertyValue) < _mcBouil) {
                                    onr.externeProp.propertyValue = _mcBouil;
                                }

                                if (isNullOrUndefined(onr.externeProp.propertyMinValue) || Number(onr.externeProp.propertyMinValue) > _mcBouil) {
                                    onr.externeProp.propertyMinValue = _mcBouil;
                                }

                            }
                        }
                        if (_blExistLegdproduct == true) {

                            //MAJ de legende max si superieur
                            this.BindingLegendStyles(legModType.items.find(a => a.legendName == precoProductLegendName), _plotPrec.Legend, null, true, true);
                        }
                    }
                    else if (legendItem) {// contrôle que le style est pas superieur

                        this.BindingLegendStyles(legendItem.items.find(a => a.legendName == precoType), _plotPrec.Legend, null, true, true);
                    }
                }

                this.OrderGroupLegend(this._legdModulations, true);
            }

        //gestion des legendes de diagnostic annuel
        if (_iblIsAnnual) {
            if (farm.PresAnnualRdt()) {
                //soit rendement precedent diag campagne N, ou rendement diag campagne N+1
                let grpLegend = !_iblIsAnnualNextCmp ? LegendsConfig.legdAnnaRend : LegendsConfig.legdAnnaRendCmpN1;
                let dictvaluesRend = new Array<LegendProperty>();
                dictvaluesRend.push(
                    this.InitLegendProperty("Exploitation", farm.NameExploitation),
                    this.InitLegendProperty("Parcelle", this.FormatPlotWithAreaText(cultivationPlot)),
                    this.InitLegendProperty("Ilot", sector.PacNumber != null ? sector.PacNumber.toString() : ""),
                    this.InitLegendProperty("Identifiant microparcelle", microPlot.MicroPlotDetails.IdBeApi),
                    this.InitLegendProperty("Rendement", (microPlot.MicroPlotDetails.Rendement != null ? microPlot.MicroPlotDetails.Rendement.toString() : ""), "T/ha"),
                    this.InitLegendProperty(LegendsConfig.legLibAnnaRend_Indic, (microPlot.MicroPlotDetails.INDICE_APY != null ? microPlot.MicroPlotDetails.INDICE_APY.toString() : ""), "%"),
                    this.InitLegendExistProperty("Protéine", microPlot.MicroPlotDetails.PROTEINE, "%"),
                    this.InitLegendExistProperty("Amidon", microPlot.MicroPlotDetails.AMIDON, "%"),
                    this.InitLegendExistProperty("Humidité", microPlot.MicroPlotDetails.HUMIDITE, "%"),
                    this.InitLegendExistProperty("Rendement moyen", cultivationPlot.Rendement && cultivationPlot.Rendement > 0 ? cultivationPlot.Rendement : null, "T/ha"),
                    this.InitLegendExistProperty("Date récolte", microPlot.MicroPlotDetails.DT_RECOLT ? HandleService.getStringLocalDate(microPlot.MicroPlotDetails.DT_RECOLT) : null),
                    this.InitLegendExistProperty("Remarques", microPlot.MicroPlotDetails.Commentary),
                )
                dictvaluesRend = this.ClearNullPropertie(dictvaluesRend);


                returnList.push({
                    legendGroupKey: grpLegend,
                    legendItemKey: "",
                    legendProperies: dictvaluesRend,
                });

                let legendRendItem = this.legend.find(a => a.key != null && a.key === grpLegend);
                if (legendRendItem != null && legendRendItem.items != null && farm.Legends != null && farm.Legends.length > 0) {
                    legendRendItem.items.forEach(item => {
                        if (item.name != null) {
                            if (item.name.toUpperCase() === LegendsConfig.legAnnaRend_Indic) {
                                this.BindingLegendsStyles(item, farm.Legends, LegendsConfig.legAnnaRend_Indic, LegendsConfig.legAnnaRend_Indic);
                            }

                            else if (item.name.toUpperCase() === LegendsConfig.legAnnaRend_Rendement) {
                                this.BindingLegendsStyles(item, farm.Legends, LegendsConfig.legAnnaRend_Rendement, LegendsConfig.legLibAnnaRend_Rendement);
                            }

                        }
                    });

                }

            }
            else if (farm.PresAnnualAzote()) {
                let dictvaluesAzote = new Array<LegendProperty>();
                dictvaluesAzote.push(
                    this.InitLegendProperty("Exploitation", farm.NameExploitation),
                    this.InitLegendProperty("Parcelle", this.FormatPlotWithAreaText(cultivationPlot)),
                    this.InitLegendProperty("Ilot", sector.PacNumber != null ? sector.PacNumber.toString() : ""),
                    this.InitLegendProperty("Identifiant microparcelle", microPlot.MicroPlotDetails.IdBeApi),
                    this.InitLegendExistProperty(LegendsConfig.legLibAnnaAzoteNAbs, (microPlot.MicroPlotDetails.Nabs_value != null ? microPlot.MicroPlotDetails.Nabs_value.toString() : null), "kg/ha"),
                    this.InitLegendExistProperty("Date Azote absorbée", microPlot.MicroPlotDetails.DT_N_ABS ? HandleService.getStringLocalDate(microPlot.MicroPlotDetails.DT_N_ABS) : null),
                    this.InitLegendExistProperty(LegendsConfig.legLibAnnaAzoteEH, (microPlot.MicroPlotDetails.BiomassEH != null ? microPlot.MicroPlotDetails.BiomassEH.toString() : ""), "kg/m²"),
                    this.InitLegendExistProperty("Date Biomasse EH", microPlot.MicroPlotDetails.DT_BIOM_EH ? HandleService.getStringLocalDate(microPlot.MicroPlotDetails.DT_BIOM_EH) : null),
                    this.InitLegendExistProperty(LegendsConfig.legLibAnnaAzoteSH, (microPlot.MicroPlotDetails.BiomassSH != null ? microPlot.MicroPlotDetails.BiomassSH.toString() : ""), "kg/m²"),
                    this.InitLegendExistProperty("Date Biomasse SH", microPlot.MicroPlotDetails.DT_BIOM_SH ? HandleService.getStringLocalDate(microPlot.MicroPlotDetails.DT_BIOM_SH) : null),
                    this.InitLegendExistProperty("Indice de nutrition Azote", microPlot.MicroPlotDetails.INN),
                    this.InitLegendExistProperty("Remarques", microPlot.MicroPlotDetails.Commentary)
                )
                dictvaluesAzote = this.ClearNullPropertie(dictvaluesAzote);
                returnList.push({
                    legendGroupKey: LegendsConfig.legdAnnaAzote,
                    legendItemKey: "",
                    legendProperies: dictvaluesAzote
                });

                let legendAztItem = this.legend.find(a => a.key != null && a.key === LegendsConfig.legdAnnaAzote);
                if (legendAztItem != null && legendAztItem.items != null && farm.Legends != null && farm.Legends.length > 0) {
                    let legPropManaged: string[] = [LegendsConfig.legAnnaAzoteEH, LegendsConfig.legAnnaAzoteSH, LegendsConfig.legAnnaAzoteNAbs];
                    legendAztItem.items.forEach(item => {

                        if (legPropManaged.find(e => e == item.name) != null) {
                            this.BindingLegendsStyles(item, farm.Legends, item.name, item.name);
                        }
                    });
                }
            } else if (farm.PresAnnualCarboN() && farm.Legends != null && farm.Legends.length > 0) {
                let dictvaluesCarboN = new Array<LegendProperty>();
                dictvaluesCarboN.push(
                    this.InitLegendProperty("Exploitation", farm.NameExploitation),
                    this.InitLegendProperty("Parcelle", this.FormatPlotWithAreaText(cultivationPlot)),
                    this.InitLegendProperty("Ilot", sector.PacNumber != null ? sector.PacNumber.toString() : ""),
                    this.InitLegendProperty("Identifiant microparcelle", microPlot.MicroPlotDetails.IdBeApi),
                    this.InitLegendExistProperty(LegendsConfig.legLibAnnaCarboN_CarboN, (microPlot.MicroPlotDetails.DVegCip != null ? microPlot.MicroPlotDetails.DVegCip.toString() : null), "t/ha"),
                    this.InitLegendExistProperty("Date Mesure", microPlot.MicroPlotDetails.MeasuredDate ? HandleService.getStringLocalDate(microPlot.MicroPlotDetails.MeasuredDate) : null),
                )

                dictvaluesCarboN = this.ClearNullPropertie(dictvaluesCarboN);
                returnList.push({
                    legendGroupKey: LegendsConfig.legdAnnaCarboN,
                    legendItemKey: "",
                    legendProperies: dictvaluesCarboN
                });
                let legendCarboNItem = this.legend.find(a => a.key != null && a.key === LegendsConfig.legdAnnaCarboN);
                if (legendCarboNItem != null && legendCarboNItem.items != null) {

                    legendCarboNItem.items.forEach(item => {
                        if (item.name == LegendsConfig.legAnnaCarboN_Biom) {
                            this.BindingLegendsStyles(item, farm.Legends, LegendsConfig.legAnnaCarboN_Biom, LegendsConfig.legLibAnnaCarboN_CarboN);
                        }
                    });
                }
            }
        }


        //gestion des legendes de diagnostic Pilot azote SP LAI
        if (_iblIsDiagLai == true) {
            let dictvaluesLAI = this.InitBasicProperties(farm, sector, cultivationPlot, microPlot, false, false, false)
            dictvaluesLAI.push(

                this.InitLegendProperty(LegendsConfig.legLibDiag_LAI, (microPlot.MicroPlotDetails.LAI != null ? microPlot.MicroPlotDetails.LAI : "")),
                this.InitLegendExistProperty("Date de mesure du LAI", microPlot.MicroPlotDetails.DT_LAI ? HandleService.getStringLocalDate(microPlot.MicroPlotDetails.DT_LAI) : null),
                this.InitLegendExistProperty("Date actualisée du LAI", microPlot.MicroPlotDetails.DT_ACT_LAI ? HandleService.getStringLocalDate(microPlot.MicroPlotDetails.DT_ACT_LAI) : null),
                this.InitLegendExistProperty("Fournisseur du LAI", microPlot.MicroPlotDetails.FOUR_LAI),

            )
            dictvaluesLAI = this.ClearNullPropertie(dictvaluesLAI);

            returnList.push({
                legendGroupKey: LegendsConfig.legdPilotSpLAI,
                legendItemKey: LegendsConfig.legDiag_SP_Lai,
                legendProperies: dictvaluesLAI
            });

            let legendLAIItem = this.legend.find(a => a.key != null && a.key === LegendsConfig.legdPilotSpLAI);
            if (legendLAIItem != null && legendLAIItem.items != null && farm.Legends != null && farm.Legends.length > 0) {
                legendLAIItem.items.forEach(item => {
                    if (item.name != null) {
                        if (item.name.toUpperCase() === LegendsConfig.legDiag_SP_Lai) {
                            this.BindingLegendsStyles(item, farm.Legends, LegendsConfig.legDiag_SP_Lai, LegendsConfig.legDiag_SP_Lai);
                        }
                    }
                });

            }
        }

        if (_blPilotOrder == true) {

            let dictvaluesAdviceLAI = this.InitBasicProperties(farm, sector, cultivationPlot, microPlot, false, false, false)
            dictvaluesAdviceLAI.push(
                this.InitLegendProperty(LegendsConfig.legLibOrd_SP_Lai_Advice_N, (microPlot.AdviceN != null ? microPlot.AdviceN : "")),
                this.InitLegendExistProperty(LegendsConfig.legLibDiag_LAI, (microPlot.MicroPlotDetails.LAI != null ? microPlot.MicroPlotDetails.LAI : "")),
                this.InitLegendExistProperty("Date de mesure du LAI", microPlot.MicroPlotDetails.DT_LAI ? HandleService.getStringLocalDate(microPlot.MicroPlotDetails.DT_LAI) : null),
                this.InitLegendExistProperty("Date actualisée du LAI", microPlot.MicroPlotDetails.DT_ACT_LAI ? HandleService.getStringLocalDate(microPlot.MicroPlotDetails.DT_ACT_LAI) : null),
                this.InitLegendExistProperty("Fournisseur du LAI", microPlot.MicroPlotDetails.FOUR_LAI),

            )
            dictvaluesAdviceLAI = this.ClearNullPropertie(dictvaluesAdviceLAI);

            returnList.push({
                legendGroupKey: LegendsConfig.legdPilotSpLAI,
                legendItemKey: LegendsConfig.legOrd_SP_Lai_Advice_N,
                legendProperies: dictvaluesAdviceLAI
            });

            let legendLAIItem = this.legend.find(a => a.key != null && a.key === LegendsConfig.legdPilotSpLAI);
            if (legendLAIItem != null && legendLAIItem.items != null && farm.Legends != null && farm.Legends.length > 0) {
                legendLAIItem.items.forEach(item => {
                    if (item.name != null) {
                        if (item.name.toUpperCase() === LegendsConfig.legOrd_SP_Lai_Advice_N) {
                            this.BindingLegendsStyles(item, farm.Legends, LegendsConfig.legOrd_SP_Lai_Advice_N, LegendsConfig.legOrd_SP_Lai_Advice_N);
                        }
                    }
                });

            }
        }


        // gestion des interventions en mode préco exclusivement
        //#region 
        if (cultivationPlot && cultivationPlot.Interventions) {
            for (let i = 0; i < cultivationPlot.Interventions.length; i++) {
                let _plInter: Intervention = new Intervention(cultivationPlot.Interventions[i], true);
                if (_plInter.IsModePreco()) {
                    if (!microPlot.Interventions || this.IsEmptyFertiDose(_plInter) || !_plInter.IncludeIdent() || _plInter.IsInterDeleted()) {
                        continue;
                    }

                    //si il a pas de preco ou pas de dose à la plot ou la micro on remplit pas
                    let _currMcInter: mcPreconisation = null;
                    if (!this.IncludeMcInterDoseByIdent(cultivationPlot, _plInter.Ident)) {//aucune micro de la plot ne dispose de dose >0
                        continue;
                    }
                    _currMcInter = microPlot.Interventions.find(t => this.EqualByIdent(t, _plInter.Ident));
                    if (!_currMcInter || this.IncludeMcFertiDose(_currMcInter, false) == false) {
                        continue;
                    }
                    let _plPrcFerti = _plInter.Fertilizer;
                    let precoProductLegendName = _plPrcFerti.Name + " - " + HandleService.getLOCALDate(_plInter.BeginDate);
                    let _blInclude_Unit = isNullOrEmptyString(_plPrcFerti.Unit) == false;
                    let _product_unit = _blInclude_Unit ? _plPrcFerti.Unit : '';

                    let dictvaluesInters = this.FormatCommonPrecoLegend(farm, sector, cultivationPlot);
                    dictvaluesInters.push(...this.InitLgendPropertiesMcPreco(microPlot, _plInter, _currMcInter, true));
                    returnList.push({
                        legendGroupKey: this._legdInterModePreco,
                        legendItemKey: precoProductLegendName,
                        legendProperies: dictvaluesInters
                    });

                    let legendItem = this.legend.find(a => a.key == this._legdInterModePreco);
                    if (legendItem && legendItem.items && !legendItem.items.find(a => a.legendName == precoProductLegendName))
                        legendItem.items.push(this.formatLegendItem(this._legdInterModePreco, precoProductLegendName, _blInclude_Unit ? _product_unit + '/ha' : '', _plInter.Legend))

                    else if (legendItem) {// contrôle que le style est pas superieur
                        this.BindingLegendStyles(legendItem.items.find(a => a.legendName == precoProductLegendName), _plInter.Legend, null, true);
                    }
                }

            }
            this.OrderLegend(this._legdInterModePreco, false);
        }
        //#endregion

        //#region Gestion Farmer intervention previs
        //si il est configuré pour la duplication selon la configuration
        if (cultivationPlot.ExistInterPrevis() && FarmerPrevisService.ConfigEnableDuplication() == true) {


            let sfxPrevisSP = FarmerPrevisService.SFX_LEGEND_PRECO_SP;

            let prestaCode = "";
            if (!_blPilotOrder) {
                if (_blMicroPk && _blMicroN) {
                    prestaCode = FarmerPrevisService.OPTION_CODE_LEGEND_PRECO_PACK;
                } else if (_blMicroPk) {
                    prestaCode = FarmerPrevisService.OPTION_CODE_LEGEND_PRECO_PK;
                } else if (_blMicroN) {
                    prestaCode = FarmerPrevisService.OPTION_CODE_LEGEND_PRECO_N;
                }
            }

            let legendFPrevis = this._legdFarmerInterPrevis;

            if (cultivationPlot.MicroPlots != null && cultivationPlot.MicroPlots.length > 0)
                for (let i = 0; i < cultivationPlot.InterPrevis.length; i++) {
                    //les prévis découlent de preconisation donc il faut les afficher sans filtrer à la dose 0
                    let _plfPrevis: InterPrevi = new InterPrevi(cultivationPlot.InterPrevis[i]);
                    let isPreviFromPilotSP = _plfPrevis.IsTechPilotSP();

                    if (!microPlot.InterPrevis || !_plfPrevis.IncludeIdent()) {
                        continue;
                    }
                    //si il a pas de dose on remplit tout de meme car l exploitant doit pouvoir la supprimer
                    let _currMcPreco: mcPreconisation = null;

                    _currMcPreco = microPlot.InterPrevis.find(t => this.EqualByIdent(t, _plfPrevis.Ident));
                    if (!_currMcPreco || this.IncludeMcFertiDose(_currMcPreco, false) == false) {

                        continue;
                    }
                    let _plPrcFerti = _plfPrevis.Fertilizer;

                    //on doit différencier les preco SP des autres
                    let precoProductLegendName = _plPrcFerti.Name + " - " + HandleService.getLOCALDate(_plfPrevis.BeginDate) + (isPreviFromPilotSP ? sfxPrevisSP : "");

                    let dictValuesFarmerPrevis: LegendProperty[] = [];
                    dictValuesFarmerPrevis = this.FormatCommonPrecoLegend(farm, sector, cultivationPlot);

                    dictValuesFarmerPrevis.push(...this.InitLgendPropertiesMcPreco(microPlot, _plfPrevis, _currMcPreco, true));

                    returnList.push({
                        legendGroupKey: legendFPrevis,
                        legendItemKey: precoProductLegendName,
                        legendProperies: dictValuesFarmerPrevis
                    });

                    let legendItem = this.legend.find(a => a.key == legendFPrevis);

                    if (legendItem && legendItem.items && !legendItem.items.find(a => a.legendName == precoProductLegendName)) {

                        let oPrecoLegend = this.formatLegendItem(legendFPrevis, precoProductLegendName, _plPrcFerti.Unit.length ? _plPrcFerti.Unit + '/ha' : '', _plfPrevis.Legend)
                        if (this._allowFarmerPrevisDuplicate == true) {
                            //derniere campagne
                            //on peut modifier la previs farmer
                            oPrecoLegend.canBeFarmerUpdated = true;
                            oPrecoLegend.uniqueFormatedId = FarmerPrevisService.FormatFarmerPrevisId(_plfPrevis);

                            if (isNullOrEmptyString(oPrecoLegend.uniqueFormatedId)) {
                                //impossible de constituer l'id unique codeproduit ou date manquant
                                oPrecoLegend.canBeFarmerUpdated = false;
                            } else {

                                if (isPreviFromPilotSP) {
                                    //ce code identifiera la previs comme Pilotage SP
                                    oPrecoLegend.options = FarmerPrevisService.OPTION_CODE_LEGEND_PRECO_SP;
                                } else {
                                    //en conseil
                                    oPrecoLegend.options = prestaCode;
                                }
                            }
                        }
                        legendItem.items.push(oPrecoLegend)
                    }

                    else if (legendItem) {// contrôle que le style est pas superieur

                        this.BindingLegendStyles(legendItem.items.find(a => a.legendName == precoProductLegendName), _plfPrevis.Legend, null, true, false);
                    }
                }

            this.OrderLegend(legendFPrevis, true);
        }

        //#endregion

        return returnList;
    }

    /**Initialise les légendes Conseil Azote */
    private BindLegendConsAzote() {
        let ObsAdviceUnit = this.adviceNPKCompoDefaultUnit;
        this.legend.push(new LegendGroup(LegendsConfig.legdAdviceN, [
            this.formatLegendItem("N", "N", ObsAdviceUnit),
            this.formatLegendItem("SO3", "SO3", ObsAdviceUnit)
        ], 9))

    }

    private getMajorObsTypeWithValue(cultivationPlot: CultivationPlot, ReqObsName: string): string {
        let MajorType = null;
        let reqMicroWithObs = cultivationPlot.MicroPlots.filter(t => t.Observations != null && t.Observations.findIndex(i => i.Name == ReqObsName && i.Value != null) !== -1);
        if (reqMicroWithObs.length > 0) {
            let Observs = reqMicroWithObs.map(t => t.Observations.filter(i => i.Name == ReqObsName && i.Value != null));
            if (Observs && Observs.length > 0) {
                Observs.forEach(element => {
                    element.forEach(a => {
                        if (MajorType == null)
                            MajorType = a.Type;
                        else if (Number(MajorType) < Number(a.Type))
                            MajorType = a.Type;
                    });
                    if (MajorType != null) {
                        return MajorType;
                    }

                });
            }
        }
        return MajorType;
    }

    /**
     * Retourne les valeurs contenues dans les observations demandées si présentes
     * @param micro données micros
     * @param ReqObsNames liste des nom des observations recherchés
     * @returns 
     */
    private getObservations(micro: MicroPlot, ReqObsNames: string[]): DictionaryModel | null {

        let oObsRequest = null;
        let reqMicroWithObs = micro.Observations != null ? micro.Observations.filter(i => ReqObsNames.includes(i.Name) && i.Value != null) : null;
        if (reqMicroWithObs != null && reqMicroWithObs.length > 0) {
            oObsRequest = new DictionaryModel();
            reqMicroWithObs.forEach(fobs => {
                oObsRequest.Set(fobs.Name, fobs.Value)
            });
        }

        return oObsRequest;
    }


    /**
     * chargement des données Conseil Azote ( Tooltip sur Micros et Legend Color)
     * Step 2-4
     * @param farm
     * @param sector
     * @param cultivationPlot
     * @param microPlot
     * @param plotMajorObsNType
     * @param plotMajorObsSo3Type
     */
    private LoadLegendConsAzote(farm: Farm, sector: Sector, cultivationPlot: CultivationPlot, microPlot: MicroPlot, plotMajorObsNType: string, plotMajorObsSo3Type: string): LegendProperties {

        let ObsAdviceUnit = this.adviceNPKCompoDefaultUnit;
        let legendAdviceN: LegendProperties = new LegendProperties;
        let dictAdviceAzote = new Array<LegendProperty>();
        let ObservN = this.getObservation(microPlot, this.ObsNameN, plotMajorObsNType, true);
        let ObservSo3 = this.getObservation(microPlot, this.ObsNameSo3, plotMajorObsSo3Type, true);
        let ObservDate = this.getObservation(microPlot, this.ObsNameDate, plotMajorObsNType, true);
        if (ObservDate == null) {
            ObservDate = this.getObservation(microPlot, this.ObsNameDate, plotMajorObsSo3Type, true);
        }
        dictAdviceAzote = this.InitBasicProperties(farm, sector, cultivationPlot, microPlot, false);
        dictAdviceAzote.push(
            this.InitLegendProperty("Date conseil", ObservDate != null ? HandleService.getLOCALDate(ObservDate.Value) : "", ''),
            this.InitLegendProperty("Objectif de rendement", microPlot.MicroPlotDetails.ObjectifRendement, "T/ha"),
            this.InitLegendProperty("N", ObservN != null ? ObservN.Value : "", ObsAdviceUnit),
            this.InitLegendProperty("SO3", ObservSo3 != null ? ObservSo3.Value : "", ObsAdviceUnit),
        );

        legendAdviceN.legendGroupKey = LegendsConfig.legdAdviceN,
            legendAdviceN.legendProperies = dictAdviceAzote;
        let legendItem = this.legend.find(a => a.key.toUpperCase() === LegendsConfig.legdAdviceN.toUpperCase());
        if (legendItem != null) {
            legendItem.items.forEach(item => {
                if (item.legendName === "N") {
                    let advice = ObservN;
                    this.BindingObsStyles(item, advice, true);
                }
                else if (item.legendName === "SO3") {
                    let advice = ObservSo3;
                    this.BindingObsStyles(item, advice, true);
                }
            })
        };
        return legendAdviceN;
    }


    /**
     * retourne l observation
     * @param microPlot
     * @param reqObsName Nom de propriété
     * @param reqObsType type filter ( 2 Update 1 Init) si pas de 2 alors retourne le 1
     * @param blForceData Indique que on ne veux QUE selon le type si celui-ci est recherché
     */
    private getObservation(microPlot: MicroPlot, reqObsName: string, reqObsType: string = null, blForceData: boolean = false) {
        let reqObservation = null;
        if (reqObsType) {
            reqObservation = microPlot.Observations.find(o => o.Name == reqObsName && o.Type == reqObsType);
            if (blForceData)
                return reqObservation;
            if (reqObservation?.value != null)
                return reqObservation;
            else
                reqObservation = null;
        }
        if (reqObservation == null)
            reqObservation = this.FindObservation(microPlot.Observations, reqObservation);

        return reqObservation;

    }


    /**
     * Ordonne les legendes selon leur clés
     * @param _LegendeKey clés
     * @param blFumure filtre specifique fumure
     */
    private OrderLegend(_LegendeKey: string, blFumure: boolean) {
        /*Ordonne les données */
        let legendModFumure = this.legend.find(a => a.key == _LegendeKey);
        if (legendModFumure && legendModFumure.Exists() && legendModFumure.items.length > 1) {
            if (!blFumure) {
                legendModFumure.items = legendModFumure.items.sort(function (a, b) {
                    return (isNullOrUndefined(a.legendName)) ? -1 : (isNullOrUndefined(b.legendName)) ? 1 : (a.legendName.toLowerCase() < b.legendName.toLowerCase()) ? -1 : (a.legendName.toLowerCase() > b.legendName.toLowerCase()) ? 1 : 0;
                });
            }
            else/** fumure filtre selon le nom et sa date */ {
                let _current = this;
                legendModFumure.items = legendModFumure.items.sort(function (a, b) {
                    let aName = isNullOrUndefined(a.legendName) ? "" : _current.getOrderFumureName(a.legendName);
                    let bName = isNullOrUndefined(b.legendName) ? "" : _current.getOrderFumureName(b.legendName);
                    return (aName < bName) ? -1 : (aName > bName) ? 1 : 0;
                });
            }
        }
    }

    /**
     *  Ordonne selon le group DONC propriete SortOn
     * @param _LegendeKey
     * @param _iblSubGrpProducts on ordonne les sous group produit-date
     */
    private OrderGroupLegend(_LegendeKey: string, _iblSubGrpProducts: boolean = false) {
        /*Ordonne les données */
        let legendProcess = this.legend.find(a => a.key == _LegendeKey);
        if (legendProcess && legendProcess.Exists()) {
            //ordonne groupe-type
            legendProcess.items = legendProcess.items.sort(function (a, b) {
                let aName = isNullOrUndefined(a.sortOn) ? "" : (a.sortOn) + '  ' + a.legendName;
                let bName = isNullOrUndefined(b.sortOn) ? "" : (b.sortOn) + '  ' + b.legendName;
                return (aName < bName) ? -1 : (aName > bName) ? 1 : 0;
            });
            if (_iblSubGrpProducts) {
                legendProcess.items.forEach((t: LegendItem) => {
                    if (t.items && t.items.length) {
                        let _current = this;
                        t.items = t.items.sort(function (a, b) {
                            let aName = isNullOrUndefined(a.legendName) ? "" : _current.getOrderFumureName(a.legendName);
                            let bName = isNullOrUndefined(b.legendName) ? "" : _current.getOrderFumureName(b.legendName);
                            return (aName < bName) ? -1 : (aName > bName) ? 1 : 0;
                        });
                    }
                }
                )
            }
        }
    }
    /**
        * retourne le nom de produit fumure permettant l ordonnancement
        * @param legendNameFumure
        */
    private getOrderFumureName(legendNameFumure: string): string {
        let oReturn = legendNameFumure;
        if (!isNullOrUndefined(legendNameFumure)) {
            oReturn = legendNameFumure.toLowerCase();
            if (legendNameFumure.lastIndexOf(' - ') > 0) {
                let _prodName = "";
                let NameSub = legendNameFumure.substr(0, legendNameFumure.lastIndexOf(' - '));
                if (NameSub != null)
                    _prodName = NameSub.toLowerCase();

                let lastItemDate: string = legendNameFumure.split(' - ').pop();

                if (lastItemDate != null) {
                    let dateformat = HandleService.stringToDate(lastItemDate);

                    if (dateformat) {
                        let isoDate = HandleService.getISODate(dateformat);
                        oReturn = _prodName + isoDate;
                    }
                }
            }
        }
        return oReturn;
    }

    /**
     * Constitution de la liste des legendes composant gauche
     * selon les données présentes
     * @param farms
     * @param valueP205
     */
    loadLegendStatic(farms: Farm[], valueP205: string): void {
        this.legend = [];
        let _blIncludePack: boolean = farms.findIndex(e => e.PresTypePack()) > -1;
        if(!_blIncludePack){
            //en GRCETA il peut en avoir en pack
            _blIncludePack = farms.findIndex(e => e.PresGRCETAOriginTypePack()) > -1;
        }
        let _blIncludePotentiel: boolean = (_blIncludePack || farms.findIndex(e => e.PresTypePotentiel()) > -1);
        let _blIncludeFerti: boolean = (_blIncludePack || farms.findIndex(e => e.PresTypeFerti() || e.PresTypeGRCETA()) > -1);
        let _blConseil = _blIncludePack || _blIncludePotentiel || _blIncludeFerti;
        let _blIncludeMods: boolean = farms.findIndex(e => e.PresTypeModulation()) > -1;
        let _blIncludeAnnuals: boolean = farms.findIndex(e => e.IsAnnualOrder()) > -1;
        let _blIncludeModePreco: boolean = farms.findIndex(e => e.HasModePreco()) > -1;

        let _blIncludeDiagLai: boolean = farms.findIndex(e => e.IsDiagPilotSPLAI()) > -1;

        let _blincludePilotLAI: boolean = farms.findIndex(e => e.IsOrderPilotSPLAI()) > -1;
        let _blincludePilotPreco: boolean = _blincludePilotLAI && farms.findIndex(e => e.HasPreco()) > -1;
        // Intègre des interventions prévisionnelles
        let _blincludeInterPrevis: boolean = farms.findIndex(e => e.HasInterPrevis()) > -1;

        //LEGENDES Specifiques Ferti
        if (_blIncludeFerti) {

            let _legDiagFerti: LegendItem[] = [
                this.formatLegendItem("pH", "pH", ''),
                this.formatLegendItem("CaO", "Teneur CaO", 'ppm'),
                this.formatLegendItem("K2O", "Teneur K2O", 'ppm'),
                this.formatLegendItem("MgO", "Teneur MgO", 'ppm'),
                this.formatLegendItem("K2O/MgO", "Teneur K2O/MgO", '')
            ];

            if (farms.findIndex(t => t.IncludeLegendName(LegendsConfig.legFertiCEC)) > -1) {
                _legDiagFerti.push(this.formatLegendItem(LegendsConfig.legFertiCEC, "CEC", 'meq/100g'))
            }

            if (farms.findIndex(t => t.IncludeLegendName(LegendsConfig.legFertiMATORG)) > -1) {
                _legDiagFerti.push(this.formatLegendItem(LegendsConfig.legFertiMATORG, "Matière organique", '%'))
            }

            this.legend.push(new LegendGroup(LegendsConfig.legDiagFerti, _legDiagFerti, 1));
        }
        //LEGENDES Specifiques Potentiel
        if (_blIncludePotentiel) {

            let leg_potentials: LegendItem[] = [
                this.formatLegendItem("Potentiel", "Potentiel", ''),
                this.formatLegendItem("RU", "Réserve utile totale", 'mm'),
                this.formatLegendItem("HCC", "Humidité capacité au champ", '%')
            ];
            if (farms.findIndex(t => t.IncludeLegendName(LegendsConfig.legPotentielAPM)) > -1) {
                leg_potentials.push(this.formatLegendItem("APM", "APM", ''))
            }

            this.legend.push(new LegendGroup(LegendsConfig.legDiagPot, leg_potentials, 2));
        }

        if (_blIncludeAnnuals) {
            if (farms.findIndex(e => e.PresAnnualRdt()) > -1) {
                this.legend.push(new LegendGroup(LegendsConfig.legdAnnaRend, [
                    this.formatLegendItem(LegendsConfig.legAnnaRend_Indic, LegendsConfig.legLibAnnaRend_Indic, '%'),
                    this.formatLegendItem(LegendsConfig.legAnnaRend_Rendement, LegendsConfig.legLibAnnaRend_Rendement, 'T/ha'),
                ], 3));

                  this.legend.push(new LegendGroup(LegendsConfig.legdAnnaRendCmpN1, [
                    this.formatLegendItem(LegendsConfig.legAnnaRend_Indic, LegendsConfig.legLibAnnaRend_Indic, '%'),
                    this.formatLegendItem(LegendsConfig.legAnnaRend_Rendement, LegendsConfig.legLibAnnaRend_Rendement, 'T/ha'),
                ], 3));
            }


            if (farms.findIndex(e => e.PresAnnualCarboN()) > -1) {
                this.legend.push(new LegendGroup(LegendsConfig.legdAnnaCarboN, [
                    this.formatLegendItem(LegendsConfig.legAnnaCarboN_Biom, LegendsConfig.legLibAnnaCarboN_CarboN, 'T/ha'),
                ], 4));
            }

            if (farms.findIndex(e => e.PresAnnualAzote()) > -1) {
                this.legend.push(new LegendGroup(LegendsConfig.legdAnnaAzote, [
                    this.formatLegendItem(LegendsConfig.legAnnaAzoteEH, LegendsConfig.legLibAnnaAzoteEH, 'kg/m²'),
                    this.formatLegendItem(LegendsConfig.legAnnaAzoteSH, LegendsConfig.legLibAnnaAzoteSH, 'kg/m²'),
                    this.formatLegendItem(LegendsConfig.legAnnaAzoteNAbs, LegendsConfig.legLibAnnaAzoteNAbs, 'kg/ha'),
                ], 5));
            };
        }

        if (_blIncludeDiagLai == true || _blincludePilotLAI == true) {
            //constitution des legendes groupées sur(Pilotage Azote SP) diag et order conseil N
            let _pilotItems: LegendItem[] = [];
            if (_blIncludeDiagLai) {
                _pilotItems.push(this.formatLegendItem(LegendsConfig.legDiag_SP_Lai, LegendsConfig.legLibDiag_LAI, ''));
            }
            if (_blincludePilotLAI) {
                _pilotItems.push(this.formatLegendItem(LegendsConfig.legOrd_SP_Lai_Advice_N, LegendsConfig.legLibOrd_SP_Lai_Advice_N, ''));
            }
            this.legend.push(new LegendGroup(LegendsConfig.legdPilotSpLAI, _pilotItems, 6));
        }

        let legAdvicePk = LegendsConfig.legdAdvicePk;
        //LEGENDES Specifiques Ferti
        if (_blIncludeFerti) {
            this.legend.push(new LegendGroup(legAdvicePk, [
                this.formatLegendItem(legAdvicePk, "P2O5", this.adviceNPKCompoDefaultUnit),
                this.formatLegendItem(legAdvicePk, "K2O", this.adviceNPKCompoDefaultUnit),
                this.formatLegendItem(legAdvicePk, "MgO", this.adviceNPKCompoDefaultUnit),
                this.formatLegendItem(legAdvicePk, "CaO", this.adviceNPKCompoDefaultUnit)
            ], 7));

            //légendes solde conseil PK
            this.legend.push(this.FormatGroupLegendAdvicePkBalances(8));
        }

        //LEGENDES Specifiques Potentiel
        if (_blIncludePotentiel)
            this.BindLegendConsAzote();

        if (_blIncludeModePreco) {
            this.legend.push(new LegendGroup(this._legdInterModePreco, [], 9));
        }

        if (_blincludeInterPrevis) {
            this.legend.push(new LegendGroup(this._legdFarmerInterPrevis, [], 13));
        }

        //LEGENDES COMMUNES
        if (_blConseil) {
            this.legend.push(new LegendGroup(this._legdPrecoFumure, [], 10));


        }
        if (_blIncludeMods) {
            this.legend.push(new LegendGroup(this._legdModulations, [], 11));
        }

        if (_blincludePilotPreco) {
            this.legend.push(new LegendGroup(this._legdPilotPreco, [], 12));
        }

        if (_blConseil) {
            this.legend.push(new LegendGroup("Assolement", [
                this.formatLegendItem("CultivationPlots", farms[0].IdCampagne.toString(), ''),
                this.formatLegendItem("CultivationPlots", (farms[0].IdCampagne - 1).toString(), ''),
                this.formatLegendItem("Sector", "Ilots", '')
            ], 14));
        }

        let legDiagFerti = LegendsConfig.legDiagFerti;
        if (_blIncludeFerti && valueP205) {
            if (valueP205 == "P2O5_OL") {
                this.legend.find(function (element) {
                    return element.key == legDiagFerti;
                }).items.splice(2, 0,
                    this.formatLegendItem("P2O5 Olsen", "Teneur P2O5 (Olsen)", 'ppm')
                );
            }
            else if (valueP205 == "PO5_JH") {

                this.legend.find(function (element) {
                    return element.key == legDiagFerti;
                }).items.splice(2, 0,
                    this.formatLegendItem("P2O5 Joret Hebert", "Teneur P2O5 (Joret Hebert)", 'ppm')
                );
            }
            else if (valueP205 == "P2O5_DY") {
                this.legend.find(function (element) {
                    return element.key == legDiagFerti;
                }).items.splice(2, 0,
                    this.formatLegendItem("P2O5 Dyer", "Teneur P2O5 (DYER)", 'ppm')
                );

            }
        }

    }


    /**
    * retourne le calcul selon l unité de la dose par la teneur
    * @param dose dose non vide
    * @param TeneurCultivationPlot valeur de la teneur
    * @param cultivationUnit unité de sortie
    */
    private GetPreconisationValue(dose: number, TeneurCultivationPlot: number, cultivationUnit: string): number {
        if (this.EmptyNumber(TeneurCultivationPlot) || dose == 0 || TeneurCultivationPlot == 0)
            return 0;

        if (!isNullOrEmptyString(cultivationUnit)) {//convertion en Kg si nécessaire
            let _ProdUnit = cultivationUnit.trim().toUpperCase();
            if (_ProdUnit == 'T' || _ProdUnit == 'M3') {
                dose = dose * 1000;
            }
            else if (_ProdUnit == 'Q') {
                dose = dose * 100;
            }
        }
        return Math.round(dose * TeneurCultivationPlot / 100) * 100 / 100;

    }

    private EmptyNumber(initValue: number): boolean {
        return initValue == null || initValue === undefined;
    }

    /**
     * initialise les legends ( tooltip) de base spécifique a l exploitation parcelle ilot
     * @param farm exploitation
     * @param sector ilot
     * @param cultivationPlot parcelle
     * @param microPlot micro (nullable)
     * @param blIncluDateAdCreate  indique si on sort cultivationPlot.AdviceCreationDate
     * @param blIncludeCulture  indique si on sort cultivationPlot.Culture
     * @param include_mc_id_advice indique si on sort l id Micro Parcelle comme Identifiant conseil
     * @returns
     */
    private InitBasicProperties(farm: Farm, sector: Sector, cultivationPlot: CultivationPlot, microPlot: MicroPlot, blIncluDateAdCreate: boolean, blIncludeCulture: boolean = true, include_mc_id_advice: boolean = true): Array<LegendProperty> {
        let _properties = new Array<LegendProperty>();
        _properties = this.InitBasicPlotProperties(farm, sector, cultivationPlot, blIncluDateAdCreate, blIncludeCulture);
        if (microPlot != null)
            _properties = _properties.concat(this.InitBasicMicroPlotProperties(microPlot, include_mc_id_advice));
        return _properties;
    }

    /**
     * initialise les legends ( tooltip) specifique a la parcelle et exploitation
     * @param farm
     * @param sector
     * @param cultivationPlot
     * @param blIncluDateAdCreate on sort cultivationPlot.AdviceCreationDate
     * @param blIncludeCulture  on sort la culture
     * @returns
     */
    private InitBasicPlotProperties(farm: Farm, sector: Sector, cultivationPlot: CultivationPlot, blIncluDateAdCreate: boolean, blIncludeCulture: boolean = true): Array<LegendProperty> {
        let dictFieldDatas = new Array<LegendProperty>();
        dictFieldDatas.push(
            this.InitLegendProperty("Exploitation", farm.NameExploitation),
            this.InitLegendProperty("Parcelle", this.FormatPlotWithAreaText(cultivationPlot)),
            this.InitLegendProperty("Ilot", sector.PacNumber != null ? sector.PacNumber.toString() : "")

        );
        if (blIncluDateAdCreate) {
            dictFieldDatas.splice(3, 0,
                this.InitLegendProperty("Date", HandleService.getLOCALDate(cultivationPlot.AdviceCreationDate)))
        }

        if (blIncludeCulture) {
            dictFieldDatas.push(
                this.InitLegendProperty("Culture", cultivationPlot.CultivationSelected ? cultivationPlot.CultivationSelected.Name : ""))
        }
        return dictFieldDatas;
    }

    /**
     * initialise les legends ( tooltip) specifique à la micro
     * @param microPlot
     * @param include_id_advice indique que l on sort l identifiant conseil
     * @returns
     */
    private InitBasicMicroPlotProperties(microPlot: MicroPlot, include_id_advice: boolean = true): Array<LegendProperty> {
        let dictPlotldDatas = new Array<LegendProperty>();
        dictPlotldDatas.push(
            this.InitLegendProperty("Identifiant microparcelle", microPlot.MicroPlotDetails.IdBeApi),
        );
        if (include_id_advice == true) {
            dictPlotldDatas.push(
                this.InitLegendProperty("Identifiant conseil", microPlot.Id.toString())
            );
        }
        return dictPlotldDatas;
    }

    /**
     * Init observation legend
     * @param newPropName nom de propriété
     * @param blIncludeObs indique si on recherche dans les observations passée
     * @param observat liste d'observation à la micro
     * @param obsNameReq nom de la propriété de l'observation
     * @param newPorpUnit unité de la propriété défaut unité dédiée conseil PK | conseil N
     * @param onEmptyValue ce qu'on retourne sur valeur vide
     * @returns LegendProperty
     */
    private InitObsLegendProperty(newPropName: string, blIncludeObs: boolean, observat: Observation[], obsNameReq: string, newPorpUnit: string = this.adviceNPKCompoDefaultUnit, onEmptyValue: string = ""): LegendProperty {
        let reqObs = blIncludeObs ? this.FindObservation(observat, obsNameReq) : null;
        return this.InitLegendProperty(newPropName, reqObs != null ? reqObs.Value : onEmptyValue, newPorpUnit, true)
    }


    /**
     * Constitution des details micros (carto) de la préconisation|previs
     * @param _iMicro  microplot
     * @param _iPlotPreco préconisation parcelle
     * @param _iMicroPreco preconisation micro
     * @param _iblIncludeCompositions tru on export l'esemble des teneurs false que la teneur N
     * @returns LegendProperty[]
     */
    private InitLgendPropertiesMcPreco(_iMicro: MicroPlot, _iPlotPreco: Intervention | InterPrevi, _iMicroPreco: mcPreconisation, _iblIncludeCompositions: boolean): LegendProperty[] {
        let oMcPrecosInfos: LegendProperty[] = [];
        let _plPrcFerti = _iPlotPreco.Fertilizer;

        let _blInclude_Unit = isNullOrEmptyString(_plPrcFerti.Unit) == false;
        let _product_unit = _blInclude_Unit ? _plPrcFerti.Unit : '';
        let formated_unit = _blInclude_Unit ? _product_unit + '/ha' : '';

        oMcPrecosInfos.push(
            this.InitLegendProperty("Identifiant microparcelle", _iMicro.MicroPlotDetails.IdBeApi),
            this.InitLegendProperty("Identifiant conseil", _iMicro.Id.toString()),
            this.InitLegendProperty("Produit", _plPrcFerti.Name),
            this.InitLegendProperty("Dose", _iMicroPreco.Fertilizer.Dose, formated_unit),
            this.InitLegendProperty("Dose moyenne à la parcelle", _plPrcFerti.Dose != null && _plPrcFerti.Dose != undefined ? _plPrcFerti.Dose : 0, formated_unit),
            this.InitLegendProperty("Date de l'apport", HandleService.getLOCALDate(_iPlotPreco.BeginDate)),
        )

        oMcPrecosInfos.push(...this.InitLegendPropertiesMcFertiCompositions(_iMicroPreco.Fertilizer.Dose, _plPrcFerti, _product_unit, _iblIncludeCompositions == false));
        return oMcPrecosInfos;
    }
    /**
     * Constitution des détails carto légend des doses de teneur par micro
     * @param _iMcDose la micro dose de produit
     * @param _iPlotFertilizer le produit fertilisant utilisé
     * @param _iProductUnit si != false prend cette unité de produit sinon celle de fertilizer
     * @param _iCompoUnit l'unité à ajouter pour la quantité de compo
     * @returns []
     */
    private InitLegendPropertiesMcFertiCompositions(_iMcDose: number, _iPlotFertilizer: Fertilizer, _iProductUnit: string = null, _iblOnlyN: boolean = false, _iCompoUnit: string = 'kg/ha'): LegendProperty[] {
        let oCompositionInfos: LegendProperty[] = [];
        let pUnit = _iPlotFertilizer.Unit;
        if (_iProductUnit !== null) {
            pUnit = _iProductUnit;
        }
        oCompositionInfos.push(
            this.InitLegendProperty("<br>N", this.GetPreconisationValue(_iMcDose, _iPlotFertilizer.N, pUnit), _iCompoUnit)
        )
        if (_iblOnlyN == false) {
            oCompositionInfos.push(
                this.InitLegendProperty("P2O5", this.GetPreconisationValue(_iMcDose, _iPlotFertilizer.P2O5, pUnit), _iCompoUnit),
                this.InitLegendProperty("K2O", this.GetPreconisationValue(_iMcDose, _iPlotFertilizer.K2O, pUnit), _iCompoUnit),
                this.InitLegendProperty("MgO", this.GetPreconisationValue(_iMcDose, _iPlotFertilizer.MgO, pUnit), _iCompoUnit),
                this.InitLegendProperty("SO3", this.GetPreconisationValue(_iMcDose, _iPlotFertilizer.SO3, pUnit), _iCompoUnit),
                this.InitLegendProperty("CaO", this.GetPreconisationValue(_iMcDose, _iPlotFertilizer.CaO, pUnit), _iCompoUnit),
                this.InitLegendProperty("Na2O", this.GetPreconisationValue(_iMcDose, _iPlotFertilizer.Na2O, pUnit), _iCompoUnit),
            )
        }

        return oCompositionInfos;
    }

    /**
     * Initialise une propriété
     * dans la synthèse le nom de la propriété apparait en gras
     * @param newPropName nom de propriété (non unique) affichée dans la synthèse en gras
     * @param newPropValue valeur affichée dans la synthèse avec "non définie" si  newPropValue ==""
     * @param newPrpUnit unité liée à la valeur (option)
     * @param blShowInTooltip indique si pour le groupe lié on affiche dans la synthèse
     * @param _iSfxValue suffix ajouté à la valeur (option)
     * @returns LegendProperty
     */
    private InitLegendProperty(newPropName: string, newPropValue: any, newPrpUnit: string = '', blShowInTooltip: boolean = true, _iSfxValue: string = null): LegendProperty {
        return new LegendProperty(newPropName, newPropValue, newPrpUnit, _iSfxValue, blShowInTooltip, undefined, false, false, false)
    }

    /**
     * filtrer les légendes en supprimant les prorpiétés indiquées
     * @param _oLegendProperties liste des propriétés de légendes à filtrer
     * @param _iRemoveLegendsName liste de nom de propriétés à suprimer
     * @returns 
     */
    private RemoveLegendPropertiesByName(_oLegendProperties: LegendProperty[], _iRemoveLegendsName:string[]): LegendProperty[] {

        if(_oLegendProperties && _oLegendProperties.length && _iRemoveLegendsName.length){
            _oLegendProperties = _oLegendProperties.filter(r=>r.propertyName ==null || _iRemoveLegendsName.includes(r.propertyName)== false);       
        }
        return _oLegendProperties;
    }

   /**
    * Filtre les légendes en supprimant les propriétés null ou vide
    * @param _oLegendProperties liste des propriétés de légendes à filtrer
    * @param _iExcludeEmptyString true: on exclue les valeurs ""
    *  @param _iExcludeValue si null null supprime les propriétés avec cette valeur
    * @returns 
    */
    private RemoveLegendPropertiesEmptyValue(_oLegendProperties: LegendProperty[], _iExcludeEmptyString:boolean, _iExcludeValue:string|null = null): LegendProperty[] {

        if(_oLegendProperties && _oLegendProperties.length){
            _oLegendProperties = _oLegendProperties.filter(r=>r.propertyValue !== null && r.propertyValue !== undefined &&(!_iExcludeEmptyString || r.propertyValue!== ""));      
            if(!isNullOrUndefined(_iExcludeValue)){
                
                 _oLegendProperties = _oLegendProperties.filter(r=>r.propertyValue!== _iExcludeValue);      
            } 
        }
        return _oLegendProperties;
    }
        /**
     * Supprime les propriétés sans valeur (valeur == null)
     * @param _ilistDatas 
     * @returns 
     */
    private ClearNullPropertie(_iLegProperties: Array<LegendProperty>): Array<LegendProperty> {
        return _iLegProperties.filter(t => t != null);
    }

    /**
     * Initialise une propriété plus optionnée
     * @param newPropName nom de propriété (non unique)
     * @param newPropValue valeur
     * @param newPrpUnit unité liée à la valeur (option)
     * @param blShowInTooltip indique si pour le groupe lié on affiche dans la synthèse
     * @param _iSfxValue suffix ajouté à la valeur
     * @param _iPropNameKey clés du nom de propriété (unique)
     * @param _iOnlyBoldIfSelected si true :indique que le nom de la propriété est en gras SEULEMENT si cette propriété est selectionnée dans la légende (groupe de légende) sinon pas en gras
     * @param _iIdentWithLi si true: on indente avec une puce (sorte de balise li)
     * @param _iAllowNullValue si true: si la valeur (newPropValue) est null il n affiche pas "non définie" à la place
     * @returns LegendProperty
     */
    private InitLegendPropertyComplet(newPropName: string, newPropValue: any, newPorpUnit: string = '', blShowInTooltip: boolean = true, _iSfxValue: string = null, _iPropNameKey: string = undefined, _iOnlyBoldIfSelected: boolean = false, _iIdentWithLi: boolean = false, _iAllowNullValue: boolean = false): LegendProperty {
        return new LegendProperty(newPropName, newPropValue, newPorpUnit, _iSfxValue, blShowInTooltip, _iPropNameKey, _iOnlyBoldIfSelected, _iIdentWithLi, _iAllowNullValue)
    }
    /**
     * Initialise UNIQUEMENT si la valeur Existe
     * @param newPropName
     * @param newPropValue
     * @param newPorpUnit
     * @param blShowInTooltip
     * @param _iSfxValue
     */
    private InitLegendExistProperty(newPropName: string, newPropValue: any, newPorpUnit: string = '', blShowInTooltip: boolean = true, _iSfxValue: string = null, _iPropNameKey: string = undefined): LegendProperty {
        if (!isNullOrUndefined(newPropValue)) {
            let oNewProp: LegendProperty = new LegendProperty(newPropName, newPropValue, newPorpUnit, _iSfxValue, blShowInTooltip, _iPropNameKey, false, false, false)
            return oNewProp;
        }
        return null;

    }


    ////////////////////// Gestion des Legendes styles (colors) left component

    /**
     * Ajout de la legende diagnostic
     * @param oLegendItem
     * @param farmLegends legendes de l'order
     * @param ReqLegendName Nom de la legende (simbologies.champ)
     * @param NewStyleName   Nouveau nom pour la légende
     */
    private BindingLegendsStyles(oLegendItem: LegendItem, farmLegends: Legend[], ReqLegendName: string, NewStyleName: string) {

        ReqLegendName = ReqLegendName.toUpperCase();
        let farmLegend: Legend = farmLegends.find(t => t.Name != null && t.Name.toUpperCase() == ReqLegendName && this.IncludeRanges(t));
        this.BindingLegendStyles(oLegendItem, farmLegend, NewStyleName);
    }

    /**
     * Met à jour la légende si un nouveau max est trouvé (ou min si blCheckMin === true)
     *
     * @param oLegendItem - Légende courante
     * @param legend - Légende de la farm
     * @param NewStyleName - Nouveau nom pour la légende
     * @param blSetLegendName - true pour utiliser le nom par défaut provenant de la farm
     * @param blCheckMin - true pour vérifier également les valeurs min en plus des valeurs max (true en intervention, préconisation, modulation)
    */
    private BindingLegendStyles(oLegendItem: LegendItem, legend: Legend, NewStyleName: string, blSetLegendName: boolean = false, blCheckMin: boolean = false) {
        if (blCheckMin) {
            const hasNewMinMax: boolean = this.IsLegendUpdateNecessary(oLegendItem.style, legend);
            if (!hasNewMinMax) {
                return;
            }
        } else {
            if (!this.OverWriteOverMaxStyle(oLegendItem.style, legend)) {
                return;
            }
        }

        // un nouveau min ou max est trouvé, on actualise le style de légende
        oLegendItem.style = new Legend;
        oLegendItem.style.Class = legend.Class;
        if (NewStyleName)
            oLegendItem.style.Name = NewStyleName;
        else if (blSetLegendName && legend.Name)
            oLegendItem.style.Name = legend.Name;
    }

    /**
     * Contrôle si la nouvelle légend peut ecraser la basic car son max est >
     * @param basicLegend
     * @param newLegend
     */
    private OverWriteOverMaxStyle(basicLegend: Legend, newLegend: Legend): boolean {

        if (this.IncludeRanges(newLegend)) {
            if (this.IncludeRanges(basicLegend)) {/*contrôle la valeur max la plus haute */
                return (basicLegend.Class[basicLegend.Class.length - 1].MaxValue < newLegend.Class[newLegend.Class.length - 1].MaxValue);
            }
            return true;
        }

        return false;
    }

    /**
     * Contrôle si la nouvelle légende possède un minimum plus petit ou un maximum plus grand que la légende actuelle.
     *
     * @param basicLegend La légende actuelle
     * @param newLegend La nouvelle légende dont il faut tester les valeurs min et max
     * @return true si une actualisation de légende est nécessaire
     */
    private IsLegendUpdateNecessary(basicLegend: Legend, newLegend: Legend): boolean {
        if (this.IncludeRanges(newLegend) && this.IncludeRanges(basicLegend)) {
            // on pointe sur le 2ème élément de la légende si plus de 1 élément
            let indexBasicLegend = basicLegend.Class.length > 1 ? 1 : 0;
            let indexNewLegend = newLegend.Class.length > 1 ? 1 : 0;

            const baseMin = basicLegend.Class[indexBasicLegend].MinValue;
            const baseMax = basicLegend.Class[basicLegend.Class.length - 1].MaxValue;
            const newMin = newLegend.Class[indexNewLegend].MinValue;
            const newMax = newLegend.Class[newLegend.Class.length - 1].MaxValue;

            return newMin < baseMin || newMax > baseMax;
        }

        return false;
    }


    /**
        * Contrôle la présence de rang de données
        * class de couleur
        */
    public IncludeRanges(basicLegend: Legend): boolean {
        return basicLegend && basicLegend.Class && basicLegend.Class.length > 0;
    }

    /**
     * constitution des Styles AU MAX de la legend [oLegendItem] selon les observations de la micro
     * @param oLegendItem legend
     * @param advice Observation
     * @param blSetLegNameOnStyle indique que l on attribue le Legendname au Style.Name
     */
    private BindingObsStyles(oLegendItem: LegendItem, advice: Observation, blSetLegNameOnStyle: boolean = true): boolean {
        if (advice && advice.Style != null && advice.Style.length > 0) {
            oLegendItem.style = this.GetLegendMaxValue(oLegendItem.style, advice.Style);
            if (blSetLegNameOnStyle && oLegendItem.style) {
                oLegendItem.style.Name = oLegendItem.legendName;
                return true;
            }
        }
        return false;
    }
    /**
     * constitution des Styles AU MAX venant d 'observation
     * @param oLegendItem legend à completer
     * @param obsName Nom de l'observation recherchée
     * @param microPlot micro contenant des observations
     * @param blSetLegNameOnStyle attribution du LegendItem.LegendName au style.name
     */
    private BindingReqObsStyles(oLegendItem: LegendItem, obsName: string, microPlot: MicroPlot, blSetLegNameOnStyle: boolean = true): boolean {
        let firstAdvice = microPlot.Observations.find(o => o.Name == obsName && o.Style != null && o.Style.length > 0);
        return this.BindingObsStyles(oLegendItem, firstAdvice, blSetLegNameOnStyle);
    }



    /**
  * Convertion d'une collection de style en legend
  * SI jsonStyle.MaxValue est > à la current.maxvalue
  */
    private GetLegendMaxValue(currentLegend: Legend, jsonStyle: JsonStyle[]) {

        if (this.IncludeRanges(currentLegend)) { // contrôle si la legend courrant est pas superieur de par sa valeur max
            if (currentLegend.Class[currentLegend.Class.length - 1].MaxValue >= jsonStyle[jsonStyle.length - 1].range) {
                return currentLegend;
            }
        }
        return this.GetLegendFromJsonStyle(jsonStyle);
    }

    /**
     * Convertion d'une collection de style en legend
     */
    private GetLegendFromJsonStyle(jsonStyle: JsonStyle[]): Legend {
        let legendToBeReturned = new Legend();
        let minValueOfLegend = 0;
        jsonStyle.forEach(element => {
            let legendColor = new LegendColor();
            legendColor.MinValue = minValueOfLegend;
            legendColor.MaxValue = element.range;
            minValueOfLegend = element.range;
            legendColor.Color = element.color;

            legendToBeReturned.Class.push(legendColor)
        });
        return legendToBeReturned;
    }
    private FindObservation(observations: Observation[], obsNameReq: string): Observation {
        return observations.find(e => e.Name == obsNameReq);
    }

    /**
     * Indique si il dispose pour la preco selon son ident
     * d'une dose à la micro
     * @param CultivationPlot
     * @param _iIdentPreco
     * @returns
     */
    private IncludeMcPrecoDoseByIdent(CultivationPlot: CultivationPlot, _iIdentPreco: number): boolean {
        if (CultivationPlot.MicroPlots && CultivationPlot.MicroPlots.length) {
            return CultivationPlot.MicroPlots.findIndex(mc => mc.Preconisations && this.IncludeMcFertiDose(mc.Preconisations.find(t => this.EqualByIdent(t, _iIdentPreco)), true)) > -1;
        }
        return false;
    }


    /**
     * Indique si il dispose pour l'inter selon son ident
     * d'une dose à la micro
     * @param CultivationPlot
     * @param _iIdentInter
     * @returns
     */
    private IncludeMcInterDoseByIdent(CultivationPlot: CultivationPlot, _identInter: number): boolean {
        if (CultivationPlot.MicroPlots && CultivationPlot.MicroPlots.length) {
            return CultivationPlot.MicroPlots.findIndex(mc => mc.Interventions && this.IncludeMcFertiDose(mc.Interventions.find(t => this.EqualByIdent(t, _identInter)), true)) > -1;
        }
        return false;
    }

    /**
 * Indique si il dispose pour l'inter previs farmer  selon son ident
 * d'une dose à la micro
 * @param CultivationPlot plot datas
 * @param _iIdentPrevis ident of the previs
 * @param _iCheckExistMc contrôle la présence de micro avant
 * @returns
 */
    private IncludeMcFPrevisDoseByIdent(CultivationPlot: CultivationPlot, _iIdentPrevis: number, _iCheckExistMc: boolean = true): boolean {
        if (_iCheckExistMc == false || CultivationPlot.MicroPlots && CultivationPlot.MicroPlots.length) {
            return CultivationPlot.MicroPlots.findIndex(mc => mc.InterPrevis && this.IncludeMcFertiDose(mc.InterPrevis.find(t => this.EqualByIdent(t, _iIdentPrevis)), true)) > -1;
        }
        return false;
    }

    private EqualByIdent(_imcPreco: mcPreconisation, _iIdent: number): boolean {
        return _imcPreco.Ident && _imcPreco.Ident != 0 && _imcPreco.Ident == _iIdent;
    }
    /**
    * Contrôle que la preco existe avec un ferti et une dose à celui ci
    * @param Preconisation
    * @param blCheckOver0Value Contrôle la présence d une dose Exclusivement superieur à 0 , si NON pas de contrôle de la valeur
    */
    private IncludeFertiDose(Preconisation: Intervention, blCheckOver0Value: boolean): boolean {
        return (this.IsEmptyFertiDose(Preconisation) == false && (blCheckOver0Value == false || Number(Preconisation.Fertilizer.Dose) > 0));
    }

    /**
 * Contrôle que la micro preco|modulation existe avec un ferti et une dose à celui ci
 * @param mcPreconisation preconisation ou modulation à la micro
 * @param blCheckOver0Value Contrôle la présence d une dose Exclusivement superieur à 0 , si NON pas de contrôle de la valeur
 */
    private IncludeMcFertiDose(mcPreconisation: mcPreconisation, blCheckOver0Value: boolean): boolean {
        return (this.IsEmptymcFertiDose(mcPreconisation) == false && (blCheckOver0Value == false || Number(mcPreconisation.Fertilizer.Dose) > 0));
    }

    /**
    * Indique si c est une preco|modulation sans dose de produit
    * @param mcPreconisation plot preco|modulation
    * @returns
    */
    private IsEmptyFertiDose(plPreconisation: Intervention) {
        return (!plPreconisation || !plPreconisation.Fertilizer || (plPreconisation.Fertilizer.Dose === null || plPreconisation.Fertilizer.Dose === undefined));
    }

    /**
     * Indique si c est une preco dans dose de produit
     * @param mcPreconisation micro preco|modulation
     * @returns
     */
    private IsEmptymcFertiDose(mcPreconisation: mcPreconisation) {
        return (!mcPreconisation || !mcPreconisation.Fertilizer || (mcPreconisation.Fertilizer.Dose === null || mcPreconisation.Fertilizer.Dose === undefined));
    }

    /**Retourne les Type Modulation pour PDF Impression */
    public getPDFModulationTypes(): any[] {
        let oReturn: any[] = [];

        if (this.IncludeLegends()) {
            let legModulation = this.legend.find(t => t.key == this._legdModulations);
            if (legModulation && legModulation.Exists()) {
                legModulation.items.forEach(t => oReturn.push({ code: t.legendCode, value: t.legendName ? t.legendName : " " }));
            }
            let legModePreco = this.legend.filter(t => (t.key == LegendsConfig.legInterModePreco) && t.Exists());
            if (legModePreco && legModePreco.length) {
                let _blModepreco = legModePreco.find(t => (t.key == LegendsConfig.legInterModePreco)) != null;
                if (_blModepreco) {
                    oReturn.splice(0, 0, { code: LegendsConfig.legInterModePrecoCode, value: LegendsConfig.legInterModePrecoName })
                }
            }

            let legPilotPreco = this.legend.filter(t => (t.key == LegendsConfig.legPilotSpPreco) && t.Exists());
            if (legPilotPreco && legPilotPreco.length) {
                let _blModepreco = legPilotPreco.find(t => (t.key == LegendsConfig.legPilotSpPreco)) != null;
                if (_blModepreco) {
                    oReturn.splice(0, 0, { code: LegendsConfig.legPilotPrecoCode, value: LegendsConfig.legPilotPrecoName })
                }
            }
        }
        return oReturn;
    }

    /**Retourne les impressions supplémentaires arrivant à la fin de la liste (synthèses) */
    public getPDFExtraPrintTypes(): PrintPdfExtraModel[] {
        let oReturn: PrintPdfExtraModel[] = [];

        if (this.IncludeLegends()) {

            let legAdvicePkPreco = this.legend.find(t => (t.key == LegendsConfig.legdAdvicePkBalance) && t.Exists());
            if (legAdvicePkPreco) {
                oReturn.push(PrintManager.FormatPdfTypeBalanceInitialAdvicePk());
                oReturn.push(PrintManager.FormatPdfTypeBalanceFertiAdvicePk());
            }

            let legModulation = this.legend.find(t => (t.key == LegendsConfig.legPilotSpPreco || t.key == this._legdPrecoFumure) && t.Exists());
            if (legModulation) {
                oReturn.push(PrintManager.FormatPdfTypeSynthesisFert())
            }
            let legModePreco = this.legend.find(t => (t.key == LegendsConfig.legdModulations) && t.Exists());
            if (legModePreco) {
                oReturn.push(PrintManager.FormatPdfTypeSynthesisOtherInputs())
            }


        }
        return oReturn;
    }

    /**Retourne la liste des PDf de Diagnostics (Annuel - Pilot LAI) Si dispose de données */
    public GetPDFDiagnosticTypes(): any[] {

        let oReturn = this.getPDFAnnualsTypes();
        let oDiagLai = this.getPDFDiagLAITypes();
        if (oDiagLai) {
            oReturn.push(oDiagLai);
        }
        return oReturn;
    }

    /**Retourne si il dispose de legende concernant le pilotage SP Diagnostic conseil ou Preconisation */
    public IncludePilotageSP():boolean {
        if (this.IncludeLegends()) {
            return this.legend.find(t => (t.key == LegendsConfig.legPilotSpPreco || t.key == LegendsConfig.legdPilotSpLAI) && t.Exists()) != undefined;
        }
        return false;
    }

     /**Retourne si il dispose de legende concernant les interventions personnalisées */
     public IncludeInterFarmer():boolean {
        if (this.IncludeLegends()) {
            return this.legend.find(t => (t.key == LegendsConfig.legendFarmerInterPrevis) && t.Exists()) != undefined;
        }
        return false;
    }

    /**Retourne si il dispose de legendes chargées */
    private IncludeLegends():boolean{
        return this.legend != null && this.legend.length>0;
    }

    /**Retourne les PrestationType Annuals pour PDF Impression */
    private getPDFAnnualsTypes(): any[] {
        let oReturn: any[] = [];
        if (this.IncludeLegends()) {
            let legAnnuals = this.legend.filter(t => (t.key == LegendsConfig.legdAnnaAzote || t.key == LegendsConfig.legdAnnaRend || t.key == LegendsConfig.legdAnnaRendCmpN1 || LegendsConfig.legdAnnaCarboN) && t.Exists());
            if (legAnnuals.length) {
                let _blRendement = legAnnuals.find(t => (t.key == LegendsConfig.legdAnnaRend)) != null;
                 let _blRendementCmpN1 = legAnnuals.find(t => (t.key == LegendsConfig.legdAnnaRendCmpN1)) != null;
                let _blAzote = legAnnuals.find(t => (t.key == LegendsConfig.legdAnnaAzote)) != null;
                let _blCarboN = legAnnuals.find(t => (t.key == LegendsConfig.legdAnnaCarboN)) != null;
                if (_blRendement) {
                    oReturn.push({ code: farmConfig.propPrest_AnnRend, value:LegendsConfig.legdAnnaRend })
                }

                if (_blRendementCmpN1) {
                    oReturn.push({ code: farmConfig.propPrest_AnnRendN1, value: LegendsConfig.legdAnnaRendCmpN1 })
                }
                if (_blAzote) {
                    oReturn.push({ code: farmConfig.propPrest_AnnAzote, value: "azote SP" })
                }
                if (_blCarboN) {
                    oReturn.push({ code: farmConfig.propPrest_AnnCarboN, value: LegendsConfig.pdfAnnaCarboN })
                }
            }
        }
        return oReturn;
    }

    /**
     * Retourne la prestation diagnostic pilot LAI pour PDF Impression
     * @returns
     */
    private getPDFDiagLAITypes(): any {
        let oReturn = null;
        if (this.IncludeLegends()) {
            let legDiagLAI = this.legend.filter(t => (t.key == LegendsConfig.legdPilotSpLAI) && t.Exists());
            if (legDiagLAI.length) {
                oReturn = { code: farmConfig.propPrest_Pilot_Azote_SP_LAI, value: "Azote SP (LAI)" };
            }
        }
        return oReturn;
    }

    /**
     *
     * @param _iName nom propriete
     * @param _iLegendName nom checkbox dans menu des legendes
     * @param _iUnit
     * @param _iStyle
     * @param _iblHasSubMenu
     * @param _iLegendCode
     * @param _ISortProp
     */
    private formatLegendItem(_iName: string, _iLegendName: string, _iUnit: string, _iStyle: Legend = undefined, _iblHasSubMenu: boolean = false, _iLegendCode: string = null, _ISortProp: string = null): LegendItem {
        return {
            name: _iName,
            legendName: _iLegendName,
            unit: _iUnit,
            style: _iStyle,
            hasSubMenu: _iblHasSubMenu,
            legendCode: _iLegendCode,
            sortOn: _ISortProp,
            items: [],
            externeProp: null,
            Basicstyle: null
        }
    }
    /**Suppression des legendes n etant pas Celle _iPropLegendKey */
    private ClearOnEmptyLegend(_iPropLegendKey: string) {
        let legendRemove = this.legend.find(a => a.key == _iPropLegendKey);
        if (legendRemove) {
            if (!legendRemove.Exists())
                this.legend = this.legend.filter(t => t.key !== _iPropLegendKey);
        }
    }

    /**Ordonne les légendes présente selon leur position indiquée */
    private OrderLegends() {
        this.legend.sort(function (n1, n2) {
            return (n1.position < n2.position) ? -1 : (n1.position > n2.position) ? 1 : 0;
        });
    }
    /**
     * Suppression des legende sans style
     * @param _iPropLegendKey
     */
    private ClearEmptyStyleLegend(_iPropLegendKey: string) {
        let _leg = this.legend.find(a => a.key == _iPropLegendKey);
        if (_leg && _leg.Exists()) {
            _leg.items = _leg.items.filter(r => r.style != null && r.style.Class != null && r.style.Class.length > 0)
        }
    }

    /**
     *
     * @param farm Exploitation
     * @param sector Parcelles
     * @param cultivationPlot Parcelle
     * @returns array
     */
    private FormatCommonPrecoLegend(_iFarm: Farm, _iSector: Sector, _iCultivationPlot: CultivationPlot) {

        let legend = [];
        legend.push(
            this.InitLegendProperty("Exploitation", _iFarm.NameExploitation),
            this.InitLegendProperty("Parcelle", this.FormatPlotWithAreaText(_iCultivationPlot)),
            this.InitLegendProperty("Ilot", _iSector.PacNumber != null ? _iSector.PacNumber.toString() : ""),
            this.InitLegendProperty("Date", HandleService.getLOCALDate(_iCultivationPlot.AdviceCreationDate)),
            this.InitLegendProperty("Culture", _iCultivationPlot.CultivationSelected ? _iCultivationPlot.CultivationSelected.Name : ""),
        );
        return legend;
    }

    /**
     * Retourne les microFeatures du group spécifié
     * @param _iLegendGroupKey spécifique à ce group de legende
     * @param _iLegendItemKey si != null filtre sur la clés de la légende
     * @returns
     */
    public GetMicroFeatureGroup(_iLegendGroupKey: string, _iLegendItemKey: string = null) {
        return this.microFeatures.filter(a => {
            let properties = a.getProperties().properties as LegendProperties[];
            let selectedProperty = properties.find(p => {
                return (p.legendGroupKey == _iLegendGroupKey && (_iLegendItemKey == null || p.legendItemKey == _iLegendItemKey));
            });
            if (selectedProperty != null)
                return a;
        });
    }

    /**Retourne selon le titre de legende si on est sur un group de preconisation ( fumur-modulation-pilotage preco - interMode preco) */
    public static IsPreconisationLegend(_iLegendTitle: string, _iblWithModulation: boolean = true) {
        let precos: string[] = [LegendsConfig.legdPrecoFumur, LegendsConfig.legPilotSpPreco, LegendsConfig.legInterModePreco, LegendsConfig.legendFarmerInterPrevis];
        if (_iblWithModulation == true) {
            precos.push(LegendsConfig.legdModulations);
        }
        return precos.includes(_iLegendTitle);
    }

    /**format un string contenant le nom de la parcelle et sa surface sur 2 deicmals max */
    private FormatPlotWithAreaText(_iPlot: CultivationPlot) {
        return `${_iPlot.NameCultivationPlot} (${HandleService.RoundDecimalsView(_iPlot.Surface, 2)} ha)`
    }

    /**Retourne pour l'ensemble des exploitations 
     * une liste distincte des P2O5EpiclesName upper présent dans les micros ferti
     */
    private GetDistinctFarmsP205EpiclesName(_iFarms: Farm[]): string[] {
        let oP2O5: string[] = [];

        let cntFerti = 0;
        if (_iFarms.length) {
            _iFarms.forEach((fFarm: Farm) => {
                if (fFarm.Sectors && (fFarm.PresTypeFerti() || fFarm.PresTypePack() || fFarm.PresTypeGRCETA())) {
                    cntFerti++;
                    //on récupère à l'order le 
                    let PrestPO5Names = fFarm.Sectors.map(s => s.CultivationPlots.map(z => z.MicroPlots.find(r => r.MicroPlotDetails.P205EpiclesName !== null && r.MicroPlotDetails.P205EpiclesName !== "")?.MicroPlotDetails.P205EpiclesName?.toLocaleUpperCase()))
                    if (PrestPO5Names.length) {
                        oP2O5.push(...HandleService.Distinct2LevelsValues(PrestPO5Names, true));
                    }
                }
            });

            if (cntFerti > 1 && oP2O5.length > 1) {
                HandleService.DistinctValues(oP2O5);
            }
            return oP2O5;
        }
    }

    //#region Legend Advice PK Balance

    /**
     * Formate le groupe de légendes solde conseil Pk
     * @param _iPosition position de la légende
     * @returns 
     */
    private FormatGroupLegendAdvicePkBalances(_iPosition: number): LegendGroup {
        return new LegendGroup(LegendsConfig.legdAdvicePkBalance, [
            this.formatLegendItem("PANAINIT", "P2O5 initial", this.adviceNPKCompoDefaultUnit),
            this.formatLegendItem("KANAINIT", "K2O initial", this.adviceNPKCompoDefaultUnit),
            this.formatLegendItem("CAANAINIT", "CaO initial", this.adviceNPKCompoDefaultUnit),
            this.formatLegendItem("MGANAINIT", "MgO initial", this.adviceNPKCompoDefaultUnit),

            this.formatLegendItem("PFERTISOL", "P2O5 réactualisé", this.adviceNPKCompoDefaultUnit),
            this.formatLegendItem("KFERTISOL", "K2O réactualisé ", this.adviceNPKCompoDefaultUnit),
            this.formatLegendItem("CAFERTISOL", "CaO réactualisé", this.adviceNPKCompoDefaultUnit),
            this.formatLegendItem("MGFERTISOL", "MgO réactualisé", this.adviceNPKCompoDefaultUnit)
        ], _iPosition);
    }
    /**
     * Génération des lignes de synthèse pour la legende Solde conseil Pk de la micro
     * @param _iMcBalance valeur de teneurs de la micro
     * @param _iCompoUnit unité de teneurs
     * @returns LegendProperty[]
     */
    private FormatLegPkBalanceSynthesis(_iMcBalance: DictionaryModel, _iCompoUnit: string): LegendProperty[] {

        let oSynthesis: LegendProperty[] = [];
        let composInit: string[][] = [["PANAINIT", "P2O5"], ["KANAINIT", "K2O"], ["CAANAINIT", "CaO"], ["MGANAINIT", "MgO"]];
        let composFerti: string[][] = [["PFERTISOL", "P2O5"], ["KFERTISOL", "K2O"], ["CAFERTISOL", "CaO"], ["MGFERTISOL", "MgO"]];

        let noneValue = "";
        oSynthesis.push(this.InitLegendPropertyComplet("<br>Analyse de terre initiale", "", "", true, "", "", false, false, true))
        for (let i = 0; i < composInit.length; i++) {
            let fCompo = composInit[i];
            oSynthesis.push(this.InitLegendPropertyComplet(fCompo[1], _iMcBalance.GetByKey(fCompo[0]) ?? noneValue, _iCompoUnit, true, "", fCompo[0], true, true));
        }
        oSynthesis.push(this.InitLegendPropertyComplet("<br>Etat de fertilité du sol réactualisé", "", "", true, "", "", false, false, true))
        for (let i = 0; i < composFerti.length; i++) {
            let fCompo = composFerti[i];
            oSynthesis.push(this.InitLegendPropertyComplet(fCompo[1], _iMcBalance.GetByKey(fCompo[0]) ?? noneValue, _iCompoUnit, true, "", fCompo[0], true, true));
        }

        return oSynthesis;
    }
    /**
    * Calcul des rangs de dose sur le solde des teneurs conseil PK
    * @param _oBalancePkInitialsValues retourné maj sur ses rang de teneurs initiales
    * @param _oBalancePkReactsValues retourné maj sur ses rang de teneurs reactualises
    * @param _iMcBalancesPk les valeurs par teneur de la micro
    * @returns _oBalancePkValues
    */
    private ComputeOrdersRangsBalances(_oBalancePkInitialsValues: DictionaryModel, _oBalancePkReactsValues: DictionaryModel, _iMcBalancesPk: DictionaryModel): DictionaryModel {
        let composKeys = ['P', 'K', 'CA', 'MG'];
        let keyMin = 'MIN_';
        let keyMax = 'MAX_';

        if (_oBalancePkInitialsValues.Exists() == false) {
            composKeys.forEach(fKey => {
                //initialise les compositions initiales sans valeurs
                _oBalancePkInitialsValues.SetWithEmptyValue(keyMin + fKey);
                _oBalancePkInitialsValues.SetWithEmptyValue(keyMax + fKey);

            })
        }
        if (_oBalancePkReactsValues.Exists() == false) {
            composKeys.forEach(fKey => {
                //initialise les compositions réactualisée sans valeurs
                _oBalancePkReactsValues.SetWithEmptyValue(keyMin + fKey);
                _oBalancePkReactsValues.SetWithEmptyValue(keyMax + fKey);

            })
        }

        if (_iMcBalancesPk != null && _iMcBalancesPk.Exists()) {
            _iMcBalancesPk.GetAllKeys().forEach(fkey => {
                let compoKey = this.getCompositionAdvicePkBalance(fkey);
                let mcValue = Number(_iMcBalancesPk.GetByKey(fkey));
                if (this.isInitialCompositionAdvicePkBalance(fkey)) {
                    if (mcValue >= Number(_oBalancePkInitialsValues.GetByKey(keyMax + compoKey))) {
                        _oBalancePkInitialsValues.Set(keyMax + compoKey, mcValue);
                    } else if (mcValue <= Number(_oBalancePkInitialsValues.GetByKey(keyMin + compoKey))) {
                        _oBalancePkInitialsValues.Set(keyMin + compoKey, mcValue);
                    }
                } else {
                    if (mcValue >= Number(_oBalancePkReactsValues.GetByKey(keyMax + compoKey))) {
                        _oBalancePkReactsValues.Set(keyMax + compoKey, mcValue);
                    } else if (mcValue <= Number(_oBalancePkReactsValues.GetByKey(keyMin + compoKey))) {
                        _oBalancePkReactsValues.Set(keyMin + compoKey, mcValue);
                    }
                }
            })
        }

        return _oBalancePkInitialsValues;
    }

    /**
     * Constitution des légendes si dispose de teneurs caculées
     * et calcul des rangs de couleurs
     * pour solde conseil PK
     * @param _iCompoInitialsRangs Rangs de chaque teneur initiales
     * @param _iCompoReactsRangs Rangs de chaque teneur réactualisées
     * @returns 
     */
    private bindAdvicePKBalanceLegends(_iCompoInitialsRangs: DictionaryModel, _iCompoReactsRangs: DictionaryModel): boolean {
        if (_iCompoInitialsRangs.Exists()) {
            let emptyCompo = _iCompoInitialsRangs.CountEmptyValue();
            if (emptyCompo > 0) {
                //présence de compo sans valeur récupérées
                if (_iCompoInitialsRangs.Count() == emptyCompo) {
                    //aucune compo présente calculée
                    _iCompoInitialsRangs.Clear();

                    return false;
                }
                _iCompoInitialsRangs.ReplaceEmptyValues(0);
            }

            let emptyCompoReact = _iCompoReactsRangs.CountEmptyValue();
            if (emptyCompoReact > 0) {
                _iCompoReactsRangs.ReplaceEmptyValues(0);
            }

            let keyMin = 'MIN_';
            let keyMax = 'MAX_';

            let config = this.configAdvicePkBalanceLegend();

            let legendBalanceItem: LegendGroup = this.legend.find(t => t.key == LegendsConfig.legdAdvicePkBalance);
            let CntDone = 0;
            if (legendBalanceItem != null && legendBalanceItem.Exists()) {
                legendBalanceItem.items.forEach((ofCompoLeg: LegendItem) => {
                    if (ofCompoLeg.name != null) {

                        let compoKey = this.getCompositionAdvicePkBalance(ofCompoLeg.name);
                        let compoLegend : Legend = this.generateAdvicePkBalanceColorsLegend(Number(_iCompoInitialsRangs.GetByKey(keyMin + compoKey)) ?? 0, Number(_iCompoInitialsRangs.GetByKey(keyMax + compoKey)) ?? 0, config, ofCompoLeg.legendName)
                        if (this.isInitialCompositionAdvicePkBalance(ofCompoLeg.name)) {
                            ofCompoLeg.style = compoLegend;
                        } else {
                         ofCompoLeg.style = this.replaceAdvicePkBalanceReactLegend(compoLegend, Number(_iCompoReactsRangs.GetByKey(keyMin + compoKey)) ?? 0, Number(_iCompoReactsRangs.GetByKey(keyMax + compoKey)) ?? 0)
                        
                        }
                        CntDone++;
                    }
                })
            }
            return CntDone > 0;
        }
        return false;
    }

    /**
    * Constitution de la légende (rang Color) calculé à la teneur
    * @param _iMinValue 
    * @param _iMaxValue 
    * @param _iConfigAPk configuration de la légende conseil Solde PK
    * @param _iLegendTitle nom de la légende affiché en titre
    * @returns 
    */
    private generateAdvicePkBalanceColorsLegend(_iMinValue: number, _iMaxValue: number, _iConfigAPk: any, _iLegendTitle: string): Legend {
        let x = Math.abs(_iMinValue) + Math.abs(_iMaxValue);
        //cas avec 1 seul rang (ex: 0)
        let onlyOne = _iMinValue == _iMaxValue;
        let oLegend = new Legend();
        oLegend.Name = _iLegendTitle;

        Object.keys(_iConfigAPk).forEach((fRangTitle: string) => {
            if (onlyOne && oLegend.Class.length == 1) {
                //le seul est constitué donc on sort
                return;
            }
            let rangColor = new LegendColor();

            let rangConfig = _iConfigAPk[fRangTitle];
            rangColor.MinValue = Math.round(Number(rangConfig['rMin'] * x));
            rangColor.MaxValue = Math.round(Number(rangConfig['rMax'] * x));
            rangColor.Color = rangConfig['color'].trim();
            rangColor.ReplaceByText(fRangTitle)
            oLegend.Class.push(rangColor);
        })
        return oLegend;
    }

    /**
    * Remplace la valeur min et max du scale de legende d'une teneur si hors rang
    * @param _oInitialScales scale legende teneur initial renvoyé maj sur donnée réactualisée
    * @param _iMinValue valeur min de la teneur en reactualisé
    * @param _iMaxValue valeur min de la teneur en reactualisé
    * @returns _oReactLegend
    */
    private replaceAdvicePkBalanceReactLegend(_iInitialLegend: Legend, _iMinValue: number, _iMaxValue: number): Legend {
        let _oReactLegend :Legend=new Legend();
        _oReactLegend.Init(_iInitialLegend)
        if (_oReactLegend && _oReactLegend.Class.length) {
            if (_iMinValue < _oReactLegend.Class[0].MinValue) {
                _oReactLegend.Class[0].MinValue = _iMinValue;
                _oReactLegend.Class[0].Tooltip = LegendColor.FormatRangTooltip(_oReactLegend.Class[0]);
            }
            let lastIndex = _oReactLegend.Class.length - 1;
            if (_iMaxValue > _oReactLegend.Class[lastIndex].MaxValue) {
                _oReactLegend.Class[lastIndex].MaxValue = _iMaxValue;
                 _oReactLegend.Class[lastIndex].Tooltip = LegendColor.FormatRangTooltip(_oReactLegend.Class[lastIndex]);
            }
        }

        return _oReactLegend;
    }

    /**
     * Configuration des rangs pour un conseil PK SOlde
     * @returns 
     */
    private configAdvicePkBalanceLegend() {

        return {
            "Très faible": { color: " #ff3d12", rMin: -1, rMax: -5 / 14 },
            "Faible": { color: " #ffae00", rMin: -5 / 14, rMax: -3 / 14 },
            "Moyen-faible": { color: " #ffff00", rMin: -3 / 14, rMax: -1 / 14 },
            "Normal": { color: "  #a4e63c", rMin: -1 / 14, rMax: 1 / 14 },
            "Moyen-élevé": { color: " #68bf36", rMin: 1 / 14, rMax: 3 / 14 },
            "Élevé": { color: " #7fd3eb", rMin: 3 / 14, rMax: 5 / 14 },
            "Très élevé": { color: " #4e8cd9", rMin: 5 / 14, rMax: 1 },
        }
    }

    /**
    * Retourne le nom simplifié de la teneur ['P', 'K', 'CA', 'MG']
    * @param adviceCompositionKey clés de composition (contenant : ANAINIT | FERTISOL)
    * @returns 
    */
    private getCompositionAdvicePkBalance(adviceCompositionKey: string) {
        return adviceCompositionKey.replace("ANAINIT", "").replace("FERTISOL", "")
    }

    /**
     * Indique si la teneur est une teneur initial , false une teneur réactualisée
     * @param adviceCompositionKey 
     * @returns 
     */
    private isInitialCompositionAdvicePkBalance(adviceCompositionKey: string) {
        return adviceCompositionKey.includes("ANAINIT");
    }
    //#endregion
}

/**Comprend les proprietes de configuration des legendes */
export class LegendsConfig {
    /**Titre groupe de la legende des modulations  "Autres préconisations" */
    public static legdModulations = "Autres modulations";
    /** Titre groupe de la legende des preconisations de fumure  "Modulation fumure" */
    public static legdPrecoFumur = "Modulation fumure";
    /** Titre groupe de la legende données annuels Rendement */
    public static legdAnnaRend = "Rendement (précédent)";
     /** Titre groupe de la legende données annuels Rendement camapgne N+1 */
    public static legdAnnaRendCmpN1 = "Rendement";

    /** Titre groupe de la legende données farmer inter previs */
    public static legendFarmerInterPrevis = "Interventions personnalisées";
    /** Titre groupe de la legende données annuels CarboN => Couverts */
    public static legdAnnaCarboN = "Couverts";

    /** Titre groupe de la legende des Preconisation en pilotage azote SP LAI */
    public static legPilotSpPreco = "Modulation Pilotage Azote SP";

    /** Titre groupe de la legende des interventions organiques de type “préconisation” */
    public static legInterModePreco = "Apports organiques";

    /** Titre du groupe de la legende Pilotage Azote SP LAI */
    public static legdPilotSpLAI = "Pilotage Azote SP";
    /** Titre groupe de la legende données annuels Azote */
    public static legdAnnaAzote = "Diagnostic Azote SP";

    /** Titre groupe de la legende données diagnostic fertilité */
    public static legDiagFerti = "Diagnostic fertilité";
    /** Titre groupe de la legende données diagnostic potentiel */
    public static legDiagPot = "Diagnostic potentiel";

    /** Titre groupe de la legende données conseil Fumure (PK) */
    public static legdAdvicePk = "Conseil fumure";

    /** Titre groupe de la legende données conseil Azote (N) */
    public static legdAdviceN = "Conseil azote";

    /** Titre groupe de la legende soldes de conseil PK */
    public static legdAdvicePkBalance = "Cartes des soldes fumure";

    public static pdfAnnaAzote = "Azote SP";
    /**titre dans l edition données annuels rendement */
    public static pdfAnnaRend = "Rendement";
    public static pdfAnnaCarboN = "Couverts";
    public static pdfDiagAzoteLAI = "Azote SP (LAI)";

    /**Code propriete Rendement 'INDICE_APY' */
    public static legAnnaRend_Indic = "INDICE_APY";
    /**Code propriete Rendement 'RENDEMENT' */
    public static legAnnaRend_Rendement = "RENDEMENT";

    /**Code propriete Carbo N 'BIOM_CI' de la legende (symbologie) */
    public static legAnnaCarboN_Biom = "BIOM_CI";

    /**Code propriete Diagnostic Azote SP LAI  : 'LAI'*/
    public static legDiag_SP_Lai = "LAI";

    /**Code propriete order Azote SP LAI conseil N calculé : 'AdviceN' */
    public static legOrd_SP_Lai_Advice_N = "ADVICEN";

    /**Code propriete annuel azote 'Biomasse EH' */
    public static legAnnaAzoteEH = "BIOM_EH";
    /**Code propriete annuel azote 'Biomasse SH' */
    public static legAnnaAzoteSH = "BIOM_SH";
    /**Code propriete annuel azote 'Biomasse SH' */
    public static legAnnaAzoteNAbs = "N_ABS";

    /**Code de la légende optionelle diagnostic potentiel APM */
    public static legPotentielAPM = "APM";

    /**Code de la légende optionelle  diagnostic Ferti CEC */
    public static legFertiCEC = "CEC";

    /**Code de la légende optionelle diagnostic Ferti MO */
    public static legFertiMATORG = "MAT_ORG";
    /**Libellé affiché pour legende et propriété MO */
    public static legLibFertiMATORG = "Matière organique";

    /**Libelle propriete Azote 'Indice APY' */
    public static legLibAnnaRend_Indic = "Indice APY";
    public static legLibAnnaRend_Rendement = "Rendement";

    public static legLibAnnaCarboN_CarboN = "Developpement CIPAN";

    /**Libelle propriete azote Sp LAI 'LAI' affiché ds tooltip et legende gauche*/
    public static legLibDiag_LAI = "LAI";

    /**Libelle propriete azote Sp LAI 'Conseil N' affiché ds tooltip et legende gauche*/
    public static legLibOrd_SP_Lai_Advice_N = "Conseil N";

    /**Libelle propriete Azote 'Biomasse EH' */
    public static legLibAnnaAzoteEH = "Biomasse EH";
    /**Libelle propriete Azote 'Biomasse SH' */
    public static legLibAnnaAzoteSH = "Biomasse SH";
    public static legLibAnnaAzoteNAbs = "Azote absorbée";
    /**Libellé de la propriete volume de bouillié à la micro */
    public static legLibMashVolumeValue = "Volume de bouillie";
    public static legLibModulationPdtDose = "Dose de produit";

    /**texte pour impression preconisation intervention mode preco */
    public static legInterModePrecoName = "fumure organique";
    /**code pour impression preconisation intervention mode preco */
    public static legInterModePrecoCode = "INTER_MODE_PRECO";

    /**texte pour impression preconisation azote SP */
    public static legPilotPrecoName = "Pilotage Azote SP";
    /**Code pour impression preconisation azote SP */
    public static legPilotPrecoCode = "PILOT_SP_PRECO";

}


